var cov_1n0vzmhyuy = function () {
  var path = '/opt/tomcat/.jenkins/workspace/delta-bitbucket-production/client/src/app/views/project/edit/isole-edit-project/projectEditCtrl.js',
      hash = 'b8eb8445bbb44e0b61f6345c30b3b97c280a06ea',
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/opt/tomcat/.jenkins/workspace/delta-bitbucket-production/client/src/app/views/project/edit/isole-edit-project/projectEditCtrl.js',
    statementMap: {
      '0': {
        start: {
          line: 5,
          column: 0
        },
        end: {
          line: 694,
          column: 3
        }
      },
      '1': {
        start: {
          line: 7,
          column: 15
        },
        end: {
          line: 7,
          column: 26
        }
      },
      '2': {
        start: {
          line: 8,
          column: 33
        },
        end: {
          line: 8,
          column: 53
        }
      },
      '3': {
        start: {
          line: 9,
          column: 32
        },
        end: {
          line: 9,
          column: 51
        }
      },
      '4': {
        start: {
          line: 10,
          column: 26
        },
        end: {
          line: 10,
          column: 45
        }
      },
      '5': {
        start: {
          line: 11,
          column: 29
        },
        end: {
          line: 11,
          column: 43
        }
      },
      '6': {
        start: {
          line: 13,
          column: 30
        },
        end: {
          line: 13,
          column: 58
        }
      },
      '7': {
        start: {
          line: 14,
          column: 27
        },
        end: {
          line: 14,
          column: 53
        }
      },
      '8': {
        start: {
          line: 15,
          column: 2
        },
        end: {
          line: 15,
          column: 25
        }
      },
      '9': {
        start: {
          line: 16,
          column: 20
        },
        end: {
          line: 16,
          column: 30
        }
      },
      '10': {
        start: {
          line: 18,
          column: 2
        },
        end: {
          line: 18,
          column: 22
        }
      },
      '11': {
        start: {
          line: 19,
          column: 2
        },
        end: {
          line: 19,
          column: 27
        }
      },
      '12': {
        start: {
          line: 21,
          column: 2
        },
        end: {
          line: 21,
          column: 60
        }
      },
      '13': {
        start: {
          line: 22,
          column: 2
        },
        end: {
          line: 22,
          column: 58
        }
      },
      '14': {
        start: {
          line: 24,
          column: 2
        },
        end: {
          line: 24,
          column: 41
        }
      },
      '15': {
        start: {
          line: 26,
          column: 2
        },
        end: {
          line: 30,
          column: 4
        }
      },
      '16': {
        start: {
          line: 32,
          column: 2
        },
        end: {
          line: 38,
          column: 4
        }
      },
      '17': {
        start: {
          line: 39,
          column: 2
        },
        end: {
          line: 46,
          column: 4
        }
      },
      '18': {
        start: {
          line: 42,
          column: 6
        },
        end: {
          line: 44,
          column: 9
        }
      },
      '19': {
        start: {
          line: 43,
          column: 8
        },
        end: {
          line: 43,
          column: 41
        }
      },
      '20': {
        start: {
          line: 48,
          column: 2
        },
        end: {
          line: 48,
          column: 114
        }
      },
      '21': {
        start: {
          line: 50,
          column: 2
        },
        end: {
          line: 50,
          column: 28
        }
      },
      '22': {
        start: {
          line: 51,
          column: 2
        },
        end: {
          line: 51,
          column: 27
        }
      },
      '23': {
        start: {
          line: 53,
          column: 2
        },
        end: {
          line: 55,
          column: 4
        }
      },
      '24': {
        start: {
          line: 56,
          column: 2
        },
        end: {
          line: 63,
          column: 4
        }
      },
      '25': {
        start: {
          line: 57,
          column: 4
        },
        end: {
          line: 57,
          column: 174
        }
      },
      '26': {
        start: {
          line: 58,
          column: 4
        },
        end: {
          line: 62,
          column: 5
        }
      },
      '27': {
        start: {
          line: 59,
          column: 16
        },
        end: {
          line: 59,
          column: 75
        }
      },
      '28': {
        start: {
          line: 60,
          column: 6
        },
        end: {
          line: 60,
          column: 21
        }
      },
      '29': {
        start: {
          line: 61,
          column: 6
        },
        end: {
          line: 61,
          column: 87
        }
      },
      '30': {
        start: {
          line: 64,
          column: 2
        },
        end: {
          line: 82,
          column: 4
        }
      },
      '31': {
        start: {
          line: 84,
          column: 2
        },
        end: {
          line: 92,
          column: 5
        }
      },
      '32': {
        start: {
          line: 85,
          column: 4
        },
        end: {
          line: 87,
          column: 5
        }
      },
      '33': {
        start: {
          line: 86,
          column: 6
        },
        end: {
          line: 86,
          column: 15
        }
      },
      '34': {
        start: {
          line: 88,
          column: 4
        },
        end: {
          line: 90,
          column: 5
        }
      },
      '35': {
        start: {
          line: 89,
          column: 6
        },
        end: {
          line: 89,
          column: 16
        }
      },
      '36': {
        start: {
          line: 91,
          column: 4
        },
        end: {
          line: 91,
          column: 13
        }
      },
      '37': {
        start: {
          line: 95,
          column: 2
        },
        end: {
          line: 203,
          column: 4
        }
      },
      '38': {
        start: {
          line: 96,
          column: 25
        },
        end: {
          line: 96,
          column: 58
        }
      },
      '39': {
        start: {
          line: 97,
          column: 4
        },
        end: {
          line: 97,
          column: 104
        }
      },
      '40': {
        start: {
          line: 98,
          column: 4
        },
        end: {
          line: 98,
          column: 104
        }
      },
      '41': {
        start: {
          line: 99,
          column: 4
        },
        end: {
          line: 99,
          column: 96
        }
      },
      '42': {
        start: {
          line: 100,
          column: 4
        },
        end: {
          line: 100,
          column: 33
        }
      },
      '43': {
        start: {
          line: 101,
          column: 4
        },
        end: {
          line: 101,
          column: 31
        }
      },
      '44': {
        start: {
          line: 102,
          column: 4
        },
        end: {
          line: 102,
          column: 84
        }
      },
      '45': {
        start: {
          line: 102,
          column: 74
        },
        end: {
          line: 102,
          column: 82
        }
      },
      '46': {
        start: {
          line: 103,
          column: 4
        },
        end: {
          line: 103,
          column: 84
        }
      },
      '47': {
        start: {
          line: 103,
          column: 74
        },
        end: {
          line: 103,
          column: 82
        }
      },
      '48': {
        start: {
          line: 104,
          column: 4
        },
        end: {
          line: 104,
          column: 113
        }
      },
      '49': {
        start: {
          line: 105,
          column: 4
        },
        end: {
          line: 105,
          column: 56
        }
      },
      '50': {
        start: {
          line: 106,
          column: 4
        },
        end: {
          line: 106,
          column: 68
        }
      },
      '51': {
        start: {
          line: 107,
          column: 4
        },
        end: {
          line: 107,
          column: 78
        }
      },
      '52': {
        start: {
          line: 108,
          column: 4
        },
        end: {
          line: 108,
          column: 71
        }
      },
      '53': {
        start: {
          line: 109,
          column: 4
        },
        end: {
          line: 109,
          column: 73
        }
      },
      '54': {
        start: {
          line: 110,
          column: 4
        },
        end: {
          line: 110,
          column: 79
        }
      },
      '55': {
        start: {
          line: 111,
          column: 4
        },
        end: {
          line: 111,
          column: 73
        }
      },
      '56': {
        start: {
          line: 112,
          column: 4
        },
        end: {
          line: 112,
          column: 63
        }
      },
      '57': {
        start: {
          line: 113,
          column: 4
        },
        end: {
          line: 113,
          column: 37
        }
      },
      '58': {
        start: {
          line: 114,
          column: 4
        },
        end: {
          line: 114,
          column: 31
        }
      },
      '59': {
        start: {
          line: 116,
          column: 4
        },
        end: {
          line: 116,
          column: 78
        }
      },
      '60': {
        start: {
          line: 117,
          column: 4
        },
        end: {
          line: 127,
          column: 6
        }
      },
      '61': {
        start: {
          line: 128,
          column: 4
        },
        end: {
          line: 131,
          column: 6
        }
      },
      '62': {
        start: {
          line: 133,
          column: 4
        },
        end: {
          line: 146,
          column: 5
        }
      },
      '63': {
        start: {
          line: 134,
          column: 19
        },
        end: {
          line: 134,
          column: 41
        }
      },
      '64': {
        start: {
          line: 135,
          column: 6
        },
        end: {
          line: 145,
          column: 7
        }
      },
      '65': {
        start: {
          line: 137,
          column: 8
        },
        end: {
          line: 144,
          column: 9
        }
      },
      '66': {
        start: {
          line: 138,
          column: 10
        },
        end: {
          line: 141,
          column: 12
        }
      },
      '67': {
        start: {
          line: 142,
          column: 10
        },
        end: {
          line: 142,
          column: 30
        }
      },
      '68': {
        start: {
          line: 143,
          column: 10
        },
        end: {
          line: 143,
          column: 17
        }
      },
      '69': {
        start: {
          line: 147,
          column: 4
        },
        end: {
          line: 154,
          column: 5
        }
      },
      '70': {
        start: {
          line: 148,
          column: 6
        },
        end: {
          line: 151,
          column: 8
        }
      },
      '71': {
        start: {
          line: 152,
          column: 6
        },
        end: {
          line: 152,
          column: 26
        }
      },
      '72': {
        start: {
          line: 153,
          column: 6
        },
        end: {
          line: 153,
          column: 13
        }
      },
      '73': {
        start: {
          line: 155,
          column: 4
        },
        end: {
          line: 162,
          column: 5
        }
      },
      '74': {
        start: {
          line: 156,
          column: 6
        },
        end: {
          line: 159,
          column: 8
        }
      },
      '75': {
        start: {
          line: 160,
          column: 6
        },
        end: {
          line: 160,
          column: 26
        }
      },
      '76': {
        start: {
          line: 161,
          column: 6
        },
        end: {
          line: 161,
          column: 13
        }
      },
      '77': {
        start: {
          line: 176,
          column: 4
        },
        end: {
          line: 202,
          column: 5
        }
      },
      '78': {
        start: {
          line: 178,
          column: 6
        },
        end: {
          line: 199,
          column: 9
        }
      },
      '79': {
        start: {
          line: 179,
          column: 8
        },
        end: {
          line: 198,
          column: 9
        }
      },
      '80': {
        start: {
          line: 180,
          column: 10
        },
        end: {
          line: 195,
          column: 13
        }
      },
      '81': {
        start: {
          line: 191,
          column: 12
        },
        end: {
          line: 193,
          column: 13
        }
      },
      '82': {
        start: {
          line: 192,
          column: 14
        },
        end: {
          line: 192,
          column: 21
        }
      },
      '83': {
        start: {
          line: 194,
          column: 12
        },
        end: {
          line: 194,
          column: 47
        }
      },
      '84': {
        start: {
          line: 197,
          column: 10
        },
        end: {
          line: 197,
          column: 45
        }
      },
      '85': {
        start: {
          line: 201,
          column: 6
        },
        end: {
          line: 201,
          column: 41
        }
      },
      '86': {
        start: {
          line: 205,
          column: 2
        },
        end: {
          line: 238,
          column: 4
        }
      },
      '87': {
        start: {
          line: 206,
          column: 19
        },
        end: {
          line: 206,
          column: 51
        }
      },
      '88': {
        start: {
          line: 207,
          column: 4
        },
        end: {
          line: 207,
          column: 28
        }
      },
      '89': {
        start: {
          line: 208,
          column: 4
        },
        end: {
          line: 237,
          column: 7
        }
      },
      '90': {
        start: {
          line: 209,
          column: 19
        },
        end: {
          line: 209,
          column: 39
        }
      },
      '91': {
        start: {
          line: 210,
          column: 6
        },
        end: {
          line: 233,
          column: 7
        }
      },
      '92': {
        start: {
          line: 211,
          column: 8
        },
        end: {
          line: 213,
          column: 9
        }
      },
      '93': {
        start: {
          line: 212,
          column: 10
        },
        end: {
          line: 212,
          column: 115
        }
      },
      '94': {
        start: {
          line: 214,
          column: 8
        },
        end: {
          line: 216,
          column: 9
        }
      },
      '95': {
        start: {
          line: 215,
          column: 10
        },
        end: {
          line: 215,
          column: 57
        }
      },
      '96': {
        start: {
          line: 217,
          column: 8
        },
        end: {
          line: 221,
          column: 9
        }
      },
      '97': {
        start: {
          line: 218,
          column: 10
        },
        end: {
          line: 218,
          column: 37
        }
      },
      '98': {
        start: {
          line: 219,
          column: 10
        },
        end: {
          line: 219,
          column: 56
        }
      },
      '99': {
        start: {
          line: 220,
          column: 10
        },
        end: {
          line: 220,
          column: 93
        }
      },
      '100': {
        start: {
          line: 222,
          column: 8
        },
        end: {
          line: 232,
          column: 9
        }
      },
      '101': {
        start: {
          line: 223,
          column: 10
        },
        end: {
          line: 231,
          column: 13
        }
      },
      '102': {
        start: {
          line: 228,
          column: 12
        },
        end: {
          line: 230,
          column: 13
        }
      },
      '103': {
        start: {
          line: 229,
          column: 14
        },
        end: {
          line: 229,
          column: 21
        }
      },
      '104': {
        start: {
          line: 234,
          column: 6
        },
        end: {
          line: 234,
          column: 22
        }
      },
      '105': {
        start: {
          line: 235,
          column: 6
        },
        end: {
          line: 235,
          column: 80
        }
      },
      '106': {
        start: {
          line: 236,
          column: 6
        },
        end: {
          line: 236,
          column: 36
        }
      },
      '107': {
        start: {
          line: 240,
          column: 2
        },
        end: {
          line: 242,
          column: 4
        }
      },
      '108': {
        start: {
          line: 244,
          column: 2
        },
        end: {
          line: 267,
          column: 4
        }
      },
      '109': {
        start: {
          line: 245,
          column: 27
        },
        end: {
          line: 245,
          column: 47
        }
      },
      '110': {
        start: {
          line: 249,
          column: 4
        },
        end: {
          line: 249,
          column: 32
        }
      },
      '111': {
        start: {
          line: 250,
          column: 4
        },
        end: {
          line: 266,
          column: 7
        }
      },
      '112': {
        start: {
          line: 251,
          column: 6
        },
        end: {
          line: 262,
          column: 9
        }
      },
      '113': {
        start: {
          line: 263,
          column: 6
        },
        end: {
          line: 263,
          column: 34
        }
      },
      '114': {
        start: {
          line: 264,
          column: 6
        },
        end: {
          line: 264,
          column: 35
        }
      },
      '115': {
        start: {
          line: 265,
          column: 6
        },
        end: {
          line: 265,
          column: 49
        }
      },
      '116': {
        start: {
          line: 269,
          column: 2
        },
        end: {
          line: 436,
          column: 4
        }
      },
      '117': {
        start: {
          line: 274,
          column: 4
        },
        end: {
          line: 307,
          column: 6
        }
      },
      '118': {
        start: {
          line: 278,
          column: 8
        },
        end: {
          line: 281,
          column: 9
        }
      },
      '119': {
        start: {
          line: 279,
          column: 10
        },
        end: {
          line: 279,
          column: 45
        }
      },
      '120': {
        start: {
          line: 280,
          column: 10
        },
        end: {
          line: 280,
          column: 17
        }
      },
      '121': {
        start: {
          line: 282,
          column: 8
        },
        end: {
          line: 282,
          column: 79
        }
      },
      '122': {
        start: {
          line: 285,
          column: 29
        },
        end: {
          line: 285,
          column: 31
        }
      },
      '123': {
        start: {
          line: 286,
          column: 21
        },
        end: {
          line: 286,
          column: 23
        }
      },
      '124': {
        start: {
          line: 287,
          column: 8
        },
        end: {
          line: 287,
          column: 27
        }
      },
      '125': {
        start: {
          line: 288,
          column: 8
        },
        end: {
          line: 292,
          column: 9
        }
      },
      '126': {
        start: {
          line: 289,
          column: 10
        },
        end: {
          line: 289,
          column: 71
        }
      },
      '127': {
        start: {
          line: 290,
          column: 10
        },
        end: {
          line: 290,
          column: 69
        }
      },
      '128': {
        start: {
          line: 291,
          column: 10
        },
        end: {
          line: 291,
          column: 30
        }
      },
      '129': {
        start: {
          line: 293,
          column: 8
        },
        end: {
          line: 293,
          column: 61
        }
      },
      '130': {
        start: {
          line: 294,
          column: 8
        },
        end: {
          line: 294,
          column: 60
        }
      },
      '131': {
        start: {
          line: 297,
          column: 29
        },
        end: {
          line: 297,
          column: 31
        }
      },
      '132': {
        start: {
          line: 298,
          column: 21
        },
        end: {
          line: 298,
          column: 23
        }
      },
      '133': {
        start: {
          line: 299,
          column: 8
        },
        end: {
          line: 302,
          column: 9
        }
      },
      '134': {
        start: {
          line: 300,
          column: 10
        },
        end: {
          line: 300,
          column: 48
        }
      },
      '135': {
        start: {
          line: 301,
          column: 10
        },
        end: {
          line: 301,
          column: 30
        }
      },
      '136': {
        start: {
          line: 303,
          column: 8
        },
        end: {
          line: 303,
          column: 61
        }
      },
      '137': {
        start: {
          line: 304,
          column: 8
        },
        end: {
          line: 304,
          column: 60
        }
      },
      '138': {
        start: {
          line: 305,
          column: 8
        },
        end: {
          line: 305,
          column: 26
        }
      },
      '139': {
        start: {
          line: 309,
          column: 4
        },
        end: {
          line: 309,
          column: 43
        }
      },
      '140': {
        start: {
          line: 310,
          column: 4
        },
        end: {
          line: 321,
          column: 7
        }
      },
      '141': {
        start: {
          line: 311,
          column: 6
        },
        end: {
          line: 320,
          column: 8
        }
      },
      '142': {
        start: {
          line: 318,
          column: 10
        },
        end: {
          line: 318,
          column: 22
        }
      },
      '143': {
        start: {
          line: 324,
          column: 4
        },
        end: {
          line: 324,
          column: 47
        }
      },
      '144': {
        start: {
          line: 325,
          column: 4
        },
        end: {
          line: 325,
          column: 29
        }
      },
      '145': {
        start: {
          line: 326,
          column: 4
        },
        end: {
          line: 326,
          column: 24
        }
      },
      '146': {
        start: {
          line: 327,
          column: 3
        },
        end: {
          line: 327,
          column: 29
        }
      },
      '147': {
        start: {
          line: 328,
          column: 4
        },
        end: {
          line: 328,
          column: 30
        }
      },
      '148': {
        start: {
          line: 329,
          column: 4
        },
        end: {
          line: 329,
          column: 24
        }
      },
      '149': {
        start: {
          line: 330,
          column: 4
        },
        end: {
          line: 330,
          column: 45
        }
      },
      '150': {
        start: {
          line: 331,
          column: 4
        },
        end: {
          line: 331,
          column: 128
        }
      },
      '151': {
        start: {
          line: 332,
          column: 4
        },
        end: {
          line: 332,
          column: 112
        }
      },
      '152': {
        start: {
          line: 334,
          column: 4
        },
        end: {
          line: 334,
          column: 41
        }
      },
      '153': {
        start: {
          line: 335,
          column: 4
        },
        end: {
          line: 337,
          column: 5
        }
      },
      '154': {
        start: {
          line: 336,
          column: 6
        },
        end: {
          line: 336,
          column: 69
        }
      },
      '155': {
        start: {
          line: 338,
          column: 4
        },
        end: {
          line: 338,
          column: 48
        }
      },
      '156': {
        start: {
          line: 340,
          column: 4
        },
        end: {
          line: 340,
          column: 130
        }
      },
      '157': {
        start: {
          line: 342,
          column: 4
        },
        end: {
          line: 344,
          column: 7
        }
      },
      '158': {
        start: {
          line: 343,
          column: 6
        },
        end: {
          line: 343,
          column: 55
        }
      },
      '159': {
        start: {
          line: 346,
          column: 4
        },
        end: {
          line: 348,
          column: 7
        }
      },
      '160': {
        start: {
          line: 347,
          column: 6
        },
        end: {
          line: 347,
          column: 64
        }
      },
      '161': {
        start: {
          line: 350,
          column: 4
        },
        end: {
          line: 350,
          column: 62
        }
      },
      '162': {
        start: {
          line: 351,
          column: 4
        },
        end: {
          line: 351,
          column: 64
        }
      },
      '163': {
        start: {
          line: 352,
          column: 4
        },
        end: {
          line: 352,
          column: 70
        }
      },
      '164': {
        start: {
          line: 353,
          column: 4
        },
        end: {
          line: 353,
          column: 64
        }
      },
      '165': {
        start: {
          line: 354,
          column: 4
        },
        end: {
          line: 354,
          column: 54
        }
      },
      '166': {
        start: {
          line: 356,
          column: 4
        },
        end: {
          line: 356,
          column: 46
        }
      },
      '167': {
        start: {
          line: 357,
          column: 4
        },
        end: {
          line: 367,
          column: 6
        }
      },
      '168': {
        start: {
          line: 368,
          column: 4
        },
        end: {
          line: 368,
          column: 40
        }
      },
      '169': {
        start: {
          line: 369,
          column: 4
        },
        end: {
          line: 369,
          column: 64
        }
      },
      '170': {
        start: {
          line: 370,
          column: 4
        },
        end: {
          line: 370,
          column: 68
        }
      },
      '171': {
        start: {
          line: 371,
          column: 4
        },
        end: {
          line: 371,
          column: 40
        }
      },
      '172': {
        start: {
          line: 375,
          column: 4
        },
        end: {
          line: 379,
          column: 5
        }
      },
      '173': {
        start: {
          line: 376,
          column: 6
        },
        end: {
          line: 378,
          column: 7
        }
      },
      '174': {
        start: {
          line: 377,
          column: 8
        },
        end: {
          line: 377,
          column: 52
        }
      },
      '175': {
        start: {
          line: 380,
          column: 4
        },
        end: {
          line: 384,
          column: 5
        }
      },
      '176': {
        start: {
          line: 381,
          column: 6
        },
        end: {
          line: 383,
          column: 7
        }
      },
      '177': {
        start: {
          line: 382,
          column: 8
        },
        end: {
          line: 382,
          column: 52
        }
      },
      '178': {
        start: {
          line: 385,
          column: 4
        },
        end: {
          line: 385,
          column: 34
        }
      },
      '179': {
        start: {
          line: 386,
          column: 4
        },
        end: {
          line: 392,
          column: 5
        }
      },
      '180': {
        start: {
          line: 387,
          column: 6
        },
        end: {
          line: 389,
          column: 9
        }
      },
      '181': {
        start: {
          line: 388,
          column: 8
        },
        end: {
          line: 388,
          column: 52
        }
      },
      '182': {
        start: {
          line: 391,
          column: 6
        },
        end: {
          line: 391,
          column: 33
        }
      },
      '183': {
        start: {
          line: 393,
          column: 4
        },
        end: {
          line: 393,
          column: 34
        }
      },
      '184': {
        start: {
          line: 394,
          column: 4
        },
        end: {
          line: 403,
          column: 7
        }
      },
      '185': {
        start: {
          line: 395,
          column: 6
        },
        end: {
          line: 400,
          column: 7
        }
      },
      '186': {
        start: {
          line: 396,
          column: 8
        },
        end: {
          line: 399,
          column: 10
        }
      },
      '187': {
        start: {
          line: 402,
          column: 6
        },
        end: {
          line: 402,
          column: 27
        }
      },
      '188': {
        start: {
          line: 404,
          column: 4
        },
        end: {
          line: 408,
          column: 6
        }
      },
      '189': {
        start: {
          line: 409,
          column: 4
        },
        end: {
          line: 412,
          column: 7
        }
      },
      '190': {
        start: {
          line: 410,
          column: 6
        },
        end: {
          line: 410,
          column: 26
        }
      },
      '191': {
        start: {
          line: 411,
          column: 6
        },
        end: {
          line: 411,
          column: 72
        }
      },
      '192': {
        start: {
          line: 413,
          column: 14
        },
        end: {
          line: 413,
          column: 91
        }
      },
      '193': {
        start: {
          line: 414,
          column: 4
        },
        end: {
          line: 418,
          column: 5
        }
      },
      '194': {
        start: {
          line: 415,
          column: 6
        },
        end: {
          line: 415,
          column: 43
        }
      },
      '195': {
        start: {
          line: 417,
          column: 6
        },
        end: {
          line: 417,
          column: 82
        }
      },
      '196': {
        start: {
          line: 419,
          column: 4
        },
        end: {
          line: 419,
          column: 50
        }
      },
      '197': {
        start: {
          line: 420,
          column: 4
        },
        end: {
          line: 420,
          column: 33
        }
      },
      '198': {
        start: {
          line: 421,
          column: 4
        },
        end: {
          line: 433,
          column: 7
        }
      },
      '199': {
        start: {
          line: 422,
          column: 6
        },
        end: {
          line: 431,
          column: 7
        }
      },
      '200': {
        start: {
          line: 423,
          column: 8
        },
        end: {
          line: 425,
          column: 9
        }
      },
      '201': {
        start: {
          line: 424,
          column: 10
        },
        end: {
          line: 424,
          column: 58
        }
      },
      '202': {
        start: {
          line: 426,
          column: 8
        },
        end: {
          line: 428,
          column: 9
        }
      },
      '203': {
        start: {
          line: 427,
          column: 10
        },
        end: {
          line: 427,
          column: 56
        }
      },
      '204': {
        start: {
          line: 430,
          column: 8
        },
        end: {
          line: 430,
          column: 39
        }
      },
      '205': {
        start: {
          line: 432,
          column: 6
        },
        end: {
          line: 432,
          column: 34
        }
      },
      '206': {
        start: {
          line: 434,
          column: 4
        },
        end: {
          line: 434,
          column: 40
        }
      },
      '207': {
        start: {
          line: 435,
          column: 4
        },
        end: {
          line: 435,
          column: 32
        }
      },
      '208': {
        start: {
          line: 438,
          column: 2
        },
        end: {
          line: 460,
          column: 5
        }
      },
      '209': {
        start: {
          line: 439,
          column: 4
        },
        end: {
          line: 441,
          column: 5
        }
      },
      '210': {
        start: {
          line: 440,
          column: 6
        },
        end: {
          line: 440,
          column: 13
        }
      },
      '211': {
        start: {
          line: 442,
          column: 4
        },
        end: {
          line: 451,
          column: 5
        }
      },
      '212': {
        start: {
          line: 443,
          column: 6
        },
        end: {
          line: 448,
          column: 36
        }
      },
      '213': {
        start: {
          line: 450,
          column: 6
        },
        end: {
          line: 450,
          column: 13
        }
      },
      '214': {
        start: {
          line: 453,
          column: 4
        },
        end: {
          line: 455,
          column: 7
        }
      },
      '215': {
        start: {
          line: 456,
          column: 4
        },
        end: {
          line: 456,
          column: 50
        }
      },
      '216': {
        start: {
          line: 458,
          column: 21
        },
        end: {
          line: 458,
          column: 207
        }
      },
      '217': {
        start: {
          line: 459,
          column: 4
        },
        end: {
          line: 459,
          column: 50
        }
      },
      '218': {
        start: {
          line: 462,
          column: 2
        },
        end: {
          line: 527,
          column: 4
        }
      },
      '219': {
        start: {
          line: 465,
          column: 17
        },
        end: {
          line: 465,
          column: 31
        }
      },
      '220': {
        start: {
          line: 467,
          column: 4
        },
        end: {
          line: 476,
          column: 5
        }
      },
      '221': {
        start: {
          line: 468,
          column: 6
        },
        end: {
          line: 472,
          column: 7
        }
      },
      '222': {
        start: {
          line: 469,
          column: 8
        },
        end: {
          line: 469,
          column: 39
        }
      },
      '223': {
        start: {
          line: 470,
          column: 8
        },
        end: {
          line: 470,
          column: 73
        }
      },
      '224': {
        start: {
          line: 471,
          column: 8
        },
        end: {
          line: 471,
          column: 72
        }
      },
      '225': {
        start: {
          line: 473,
          column: 6
        },
        end: {
          line: 475,
          column: 7
        }
      },
      '226': {
        start: {
          line: 474,
          column: 8
        },
        end: {
          line: 474,
          column: 15
        }
      },
      '227': {
        start: {
          line: 477,
          column: 4
        },
        end: {
          line: 477,
          column: 26
        }
      },
      '228': {
        start: {
          line: 478,
          column: 4
        },
        end: {
          line: 525,
          column: 7
        }
      },
      '229': {
        start: {
          line: 479,
          column: 6
        },
        end: {
          line: 482,
          column: 7
        }
      },
      '230': {
        start: {
          line: 480,
          column: 8
        },
        end: {
          line: 480,
          column: 31
        }
      },
      '231': {
        start: {
          line: 481,
          column: 8
        },
        end: {
          line: 481,
          column: 15
        }
      },
      '232': {
        start: {
          line: 483,
          column: 6
        },
        end: {
          line: 517,
          column: 7
        }
      },
      '233': {
        start: {
          line: 484,
          column: 8
        },
        end: {
          line: 486,
          column: 9
        }
      },
      '234': {
        start: {
          line: 485,
          column: 10
        },
        end: {
          line: 485,
          column: 19
        }
      },
      '235': {
        start: {
          line: 487,
          column: 8
        },
        end: {
          line: 487,
          column: 79
        }
      },
      '236': {
        start: {
          line: 488,
          column: 8
        },
        end: {
          line: 488,
          column: 72
        }
      },
      '237': {
        start: {
          line: 489,
          column: 8
        },
        end: {
          line: 489,
          column: 42
        }
      },
      '238': {
        start: {
          line: 490,
          column: 8
        },
        end: {
          line: 490,
          column: 76
        }
      },
      '239': {
        start: {
          line: 491,
          column: 8
        },
        end: {
          line: 491,
          column: 72
        }
      },
      '240': {
        start: {
          line: 492,
          column: 8
        },
        end: {
          line: 492,
          column: 77
        }
      },
      '241': {
        start: {
          line: 493,
          column: 22
        },
        end: {
          line: 493,
          column: 71
        }
      },
      '242': {
        start: {
          line: 494,
          column: 8
        },
        end: {
          line: 494,
          column: 29
        }
      },
      '243': {
        start: {
          line: 495,
          column: 8
        },
        end: {
          line: 497,
          column: 9
        }
      },
      '244': {
        start: {
          line: 496,
          column: 10
        },
        end: {
          line: 496,
          column: 90
        }
      },
      '245': {
        start: {
          line: 498,
          column: 8
        },
        end: {
          line: 500,
          column: 9
        }
      },
      '246': {
        start: {
          line: 499,
          column: 10
        },
        end: {
          line: 499,
          column: 31
        }
      },
      '247': {
        start: {
          line: 501,
          column: 8
        },
        end: {
          line: 501,
          column: 64
        }
      },
      '248': {
        start: {
          line: 503,
          column: 8
        },
        end: {
          line: 516,
          column: 10
        }
      },
      '249': {
        start: {
          line: 519,
          column: 6
        },
        end: {
          line: 524,
          column: 7
        }
      },
      '250': {
        start: {
          line: 520,
          column: 8
        },
        end: {
          line: 520,
          column: 31
        }
      },
      '251': {
        start: {
          line: 521,
          column: 8
        },
        end: {
          line: 521,
          column: 29
        }
      },
      '252': {
        start: {
          line: 523,
          column: 8
        },
        end: {
          line: 523,
          column: 31
        }
      },
      '253': {
        start: {
          line: 529,
          column: 2
        },
        end: {
          line: 531,
          column: 5
        }
      },
      '254': {
        start: {
          line: 530,
          column: 4
        },
        end: {
          line: 530,
          column: 127
        }
      },
      '255': {
        start: {
          line: 533,
          column: 2
        },
        end: {
          line: 555,
          column: 5
        }
      },
      '256': {
        start: {
          line: 534,
          column: 4
        },
        end: {
          line: 534,
          column: 84
        }
      },
      '257': {
        start: {
          line: 536,
          column: 4
        },
        end: {
          line: 536,
          column: 32
        }
      },
      '258': {
        start: {
          line: 538,
          column: 4
        },
        end: {
          line: 554,
          column: 7
        }
      },
      '259': {
        start: {
          line: 539,
          column: 6
        },
        end: {
          line: 539,
          column: 57
        }
      },
      '260': {
        start: {
          line: 541,
          column: 6
        },
        end: {
          line: 551,
          column: 7
        }
      },
      '261': {
        start: {
          line: 542,
          column: 8
        },
        end: {
          line: 546,
          column: 9
        }
      },
      '262': {
        start: {
          line: 543,
          column: 10
        },
        end: {
          line: 545,
          column: 13
        }
      },
      '263': {
        start: {
          line: 544,
          column: 12
        },
        end: {
          line: 544,
          column: 64
        }
      },
      '264': {
        start: {
          line: 548,
          column: 8
        },
        end: {
          line: 550,
          column: 9
        }
      },
      '265': {
        start: {
          line: 549,
          column: 10
        },
        end: {
          line: 549,
          column: 63
        }
      },
      '266': {
        start: {
          line: 553,
          column: 6
        },
        end: {
          line: 553,
          column: 35
        }
      },
      '267': {
        start: {
          line: 557,
          column: 2
        },
        end: {
          line: 559,
          column: 4
        }
      },
      '268': {
        start: {
          line: 558,
          column: 4
        },
        end: {
          line: 558,
          column: 57
        }
      },
      '269': {
        start: {
          line: 561,
          column: 2
        },
        end: {
          line: 583,
          column: 4
        }
      },
      '270': {
        start: {
          line: 562,
          column: 4
        },
        end: {
          line: 562,
          column: 30
        }
      },
      '271': {
        start: {
          line: 563,
          column: 4
        },
        end: {
          line: 574,
          column: 6
        }
      },
      '272': {
        start: {
          line: 575,
          column: 4
        },
        end: {
          line: 582,
          column: 7
        }
      },
      '273': {
        start: {
          line: 584,
          column: 2
        },
        end: {
          line: 598,
          column: 4
        }
      },
      '274': {
        start: {
          line: 585,
          column: 4
        },
        end: {
          line: 590,
          column: 5
        }
      },
      '275': {
        start: {
          line: 586,
          column: 6
        },
        end: {
          line: 588,
          column: 9
        }
      },
      '276': {
        start: {
          line: 587,
          column: 8
        },
        end: {
          line: 587,
          column: 36
        }
      },
      '277': {
        start: {
          line: 589,
          column: 6
        },
        end: {
          line: 589,
          column: 13
        }
      },
      '278': {
        start: {
          line: 591,
          column: 4
        },
        end: {
          line: 596,
          column: 5
        }
      },
      '279': {
        start: {
          line: 592,
          column: 6
        },
        end: {
          line: 595,
          column: 7
        }
      },
      '280': {
        start: {
          line: 593,
          column: 8
        },
        end: {
          line: 593,
          column: 38
        }
      },
      '281': {
        start: {
          line: 594,
          column: 8
        },
        end: {
          line: 594,
          column: 15
        }
      },
      '282': {
        start: {
          line: 597,
          column: 4
        },
        end: {
          line: 597,
          column: 31
        }
      },
      '283': {
        start: {
          line: 600,
          column: 2
        },
        end: {
          line: 609,
          column: 4
        }
      },
      '284': {
        start: {
          line: 601,
          column: 4
        },
        end: {
          line: 608,
          column: 7
        }
      },
      '285': {
        start: {
          line: 610,
          column: 2
        },
        end: {
          line: 625,
          column: 5
        }
      },
      '286': {
        start: {
          line: 611,
          column: 4
        },
        end: {
          line: 616,
          column: 5
        }
      },
      '287': {
        start: {
          line: 612,
          column: 6
        },
        end: {
          line: 614,
          column: 9
        }
      },
      '288': {
        start: {
          line: 613,
          column: 8
        },
        end: {
          line: 613,
          column: 36
        }
      },
      '289': {
        start: {
          line: 615,
          column: 6
        },
        end: {
          line: 615,
          column: 13
        }
      },
      '290': {
        start: {
          line: 617,
          column: 4
        },
        end: {
          line: 623,
          column: 5
        }
      },
      '291': {
        start: {
          line: 618,
          column: 6
        },
        end: {
          line: 622,
          column: 7
        }
      },
      '292': {
        start: {
          line: 619,
          column: 8
        },
        end: {
          line: 619,
          column: 32
        }
      },
      '293': {
        start: {
          line: 620,
          column: 8
        },
        end: {
          line: 620,
          column: 34
        }
      },
      '294': {
        start: {
          line: 621,
          column: 8
        },
        end: {
          line: 621,
          column: 15
        }
      },
      '295': {
        start: {
          line: 624,
          column: 4
        },
        end: {
          line: 624,
          column: 30
        }
      },
      '296': {
        start: {
          line: 627,
          column: 2
        },
        end: {
          line: 645,
          column: 4
        }
      },
      '297': {
        start: {
          line: 631,
          column: 4
        },
        end: {
          line: 631,
          column: 35
        }
      },
      '298': {
        start: {
          line: 634,
          column: 17
        },
        end: {
          line: 634,
          column: 99
        }
      },
      '299': {
        start: {
          line: 634,
          column: 85
        },
        end: {
          line: 634,
          column: 97
        }
      },
      '300': {
        start: {
          line: 636,
          column: 4
        },
        end: {
          line: 636,
          column: 32
        }
      },
      '301': {
        start: {
          line: 637,
          column: 4
        },
        end: {
          line: 637,
          column: 48
        }
      },
      '302': {
        start: {
          line: 647,
          column: 2
        },
        end: {
          line: 686,
          column: 4
        }
      },
      '303': {
        start: {
          line: 649,
          column: 4
        },
        end: {
          line: 661,
          column: 7
        }
      },
      '304': {
        start: {
          line: 650,
          column: 6
        },
        end: {
          line: 660,
          column: 7
        }
      },
      '305': {
        start: {
          line: 651,
          column: 8
        },
        end: {
          line: 657,
          column: 10
        }
      },
      '306': {
        start: {
          line: 659,
          column: 8
        },
        end: {
          line: 659,
          column: 47
        }
      },
      '307': {
        start: {
          line: 663,
          column: 4
        },
        end: {
          line: 673,
          column: 7
        }
      },
      '308': {
        start: {
          line: 664,
          column: 6
        },
        end: {
          line: 672,
          column: 7
        }
      },
      '309': {
        start: {
          line: 665,
          column: 8
        },
        end: {
          line: 669,
          column: 10
        }
      },
      '310': {
        start: {
          line: 671,
          column: 8
        },
        end: {
          line: 671,
          column: 44
        }
      },
      '311': {
        start: {
          line: 675,
          column: 4
        },
        end: {
          line: 679,
          column: 7
        }
      },
      '312': {
        start: {
          line: 676,
          column: 6
        },
        end: {
          line: 676,
          column: 29
        }
      },
      '313': {
        start: {
          line: 677,
          column: 6
        },
        end: {
          line: 677,
          column: 36
        }
      },
      '314': {
        start: {
          line: 678,
          column: 6
        },
        end: {
          line: 678,
          column: 44
        }
      },
      '315': {
        start: {
          line: 681,
          column: 4
        },
        end: {
          line: 684,
          column: 7
        }
      },
      '316': {
        start: {
          line: 682,
          column: 6
        },
        end: {
          line: 682,
          column: 28
        }
      },
      '317': {
        start: {
          line: 689,
          column: 2
        },
        end: {
          line: 689,
          column: 23
        }
      },
      '318': {
        start: {
          line: 690,
          column: 2
        },
        end: {
          line: 690,
          column: 26
        }
      },
      '319': {
        start: {
          line: 692,
          column: 2
        },
        end: {
          line: 692,
          column: 54
        }
      },
      '320': {
        start: {
          line: 698,
          column: 2
        },
        end: {
          line: 698,
          column: 37
        }
      },
      '321': {
        start: {
          line: 699,
          column: 2
        },
        end: {
          line: 701,
          column: 8
        }
      },
      '322': {
        start: {
          line: 700,
          column: 4
        },
        end: {
          line: 700,
          column: 64
        }
      },
      '323': {
        start: {
          line: 703,
          column: 2
        },
        end: {
          line: 703,
          column: 28
        }
      },
      '324': {
        start: {
          line: 704,
          column: 15
        },
        end: {
          line: 704,
          column: 32
        }
      },
      '325': {
        start: {
          line: 706,
          column: 2
        },
        end: {
          line: 719,
          column: 5
        }
      },
      '326': {
        start: {
          line: 707,
          column: 4
        },
        end: {
          line: 718,
          column: 7
        }
      },
      '327': {
        start: {
          line: 721,
          column: 2
        },
        end: {
          line: 731,
          column: 5
        }
      },
      '328': {
        start: {
          line: 722,
          column: 18
        },
        end: {
          line: 724,
          column: 6
        }
      },
      '329': {
        start: {
          line: 723,
          column: 6
        },
        end: {
          line: 723,
          column: 43
        }
      },
      '330': {
        start: {
          line: 726,
          column: 4
        },
        end: {
          line: 728,
          column: 5
        }
      },
      '331': {
        start: {
          line: 727,
          column: 6
        },
        end: {
          line: 727,
          column: 36
        }
      },
      '332': {
        start: {
          line: 730,
          column: 4
        },
        end: {
          line: 730,
          column: 85
        }
      },
      '333': {
        start: {
          line: 733,
          column: 2
        },
        end: {
          line: 750,
          column: 4
        }
      },
      '334': {
        start: {
          line: 734,
          column: 25
        },
        end: {
          line: 734,
          column: 60
        }
      },
      '335': {
        start: {
          line: 735,
          column: 4
        },
        end: {
          line: 735,
          column: 27
        }
      },
      '336': {
        start: {
          line: 736,
          column: 18
        },
        end: {
          line: 736,
          column: 91
        }
      },
      '337': {
        start: {
          line: 737,
          column: 4
        },
        end: {
          line: 742,
          column: 5
        }
      },
      '338': {
        start: {
          line: 738,
          column: 6
        },
        end: {
          line: 741,
          column: 7
        }
      },
      '339': {
        start: {
          line: 739,
          column: 8
        },
        end: {
          line: 739,
          column: 38
        }
      },
      '340': {
        start: {
          line: 740,
          column: 8
        },
        end: {
          line: 740,
          column: 15
        }
      },
      '341': {
        start: {
          line: 743,
          column: 4
        },
        end: {
          line: 743,
          column: 57
        }
      },
      '342': {
        start: {
          line: 744,
          column: 4
        },
        end: {
          line: 749,
          column: 7
        }
      },
      '343': {
        start: {
          line: 745,
          column: 6
        },
        end: {
          line: 745,
          column: 51
        }
      },
      '344': {
        start: {
          line: 746,
          column: 6
        },
        end: {
          line: 746,
          column: 42
        }
      },
      '345': {
        start: {
          line: 747,
          column: 6
        },
        end: {
          line: 747,
          column: 35
        }
      },
      '346': {
        start: {
          line: 752,
          column: 2
        },
        end: {
          line: 754,
          column: 5
        }
      },
      '347': {
        start: {
          line: 753,
          column: 4
        },
        end: {
          line: 753,
          column: 33
        }
      },
      '348': {
        start: {
          line: 756,
          column: 2
        },
        end: {
          line: 788,
          column: 5
        }
      },
      '349': {
        start: {
          line: 757,
          column: 4
        },
        end: {
          line: 787,
          column: 7
        }
      },
      '350': {
        start: {
          line: 769,
          column: 6
        },
        end: {
          line: 771,
          column: 7
        }
      },
      '351': {
        start: {
          line: 770,
          column: 8
        },
        end: {
          line: 770,
          column: 15
        }
      },
      '352': {
        start: {
          line: 772,
          column: 6
        },
        end: {
          line: 772,
          column: 30
        }
      },
      '353': {
        start: {
          line: 773,
          column: 27
        },
        end: {
          line: 775,
          column: 7
        }
      },
      '354': {
        start: {
          line: 776,
          column: 6
        },
        end: {
          line: 786,
          column: 9
        }
      },
      '355': {
        start: {
          line: 777,
          column: 8
        },
        end: {
          line: 784,
          column: 9
        }
      },
      '356': {
        start: {
          line: 778,
          column: 10
        },
        end: {
          line: 781,
          column: 13
        }
      },
      '357': {
        start: {
          line: 782,
          column: 10
        },
        end: {
          line: 782,
          column: 35
        }
      },
      '358': {
        start: {
          line: 783,
          column: 10
        },
        end: {
          line: 783,
          column: 17
        }
      },
      '359': {
        start: {
          line: 785,
          column: 8
        },
        end: {
          line: 785,
          column: 50
        }
      },
      '360': {
        start: {
          line: 790,
          column: 2
        },
        end: {
          line: 792,
          column: 4
        }
      },
      '361': {
        start: {
          line: 791,
          column: 4
        },
        end: {
          line: 791,
          column: 40
        }
      },
      '362': {
        start: {
          line: 796,
          column: 2
        },
        end: {
          line: 801,
          column: 4
        }
      },
      '363': {
        start: {
          line: 797,
          column: 4
        },
        end: {
          line: 800,
          column: 7
        }
      },
      '364': {
        start: {
          line: 803,
          column: 2
        },
        end: {
          line: 806,
          column: 4
        }
      },
      '365': {
        start: {
          line: 804,
          column: 4
        },
        end: {
          line: 804,
          column: 28
        }
      },
      '366': {
        start: {
          line: 805,
          column: 4
        },
        end: {
          line: 805,
          column: 47
        }
      },
      '367': {
        start: {
          line: 808,
          column: 2
        },
        end: {
          line: 810,
          column: 5
        }
      },
      '368': {
        start: {
          line: 809,
          column: 4
        },
        end: {
          line: 809,
          column: 33
        }
      },
      '369': {
        start: {
          line: 812,
          column: 2
        },
        end: {
          line: 829,
          column: 5
        }
      },
      '370': {
        start: {
          line: 813,
          column: 4
        },
        end: {
          line: 813,
          column: 28
        }
      },
      '371': {
        start: {
          line: 815,
          column: 4
        },
        end: {
          line: 820,
          column: 5
        }
      },
      '372': {
        start: {
          line: 816,
          column: 6
        },
        end: {
          line: 816,
          column: 125
        }
      },
      '373': {
        start: {
          line: 818,
          column: 6
        },
        end: {
          line: 818,
          column: 36
        }
      },
      '374': {
        start: {
          line: 819,
          column: 6
        },
        end: {
          line: 819,
          column: 13
        }
      },
      '375': {
        start: {
          line: 822,
          column: 4
        },
        end: {
          line: 828,
          column: 7
        }
      },
      '376': {
        start: {
          line: 823,
          column: 6
        },
        end: {
          line: 823,
          column: 60
        }
      },
      '377': {
        start: {
          line: 824,
          column: 6
        },
        end: {
          line: 824,
          column: 63
        }
      },
      '378': {
        start: {
          line: 825,
          column: 6
        },
        end: {
          line: 825,
          column: 35
        }
      },
      '379': {
        start: {
          line: 830,
          column: 2
        },
        end: {
          line: 862,
          column: 5
        }
      },
      '380': {
        start: {
          line: 831,
          column: 4
        },
        end: {
          line: 861,
          column: 7
        }
      },
      '381': {
        start: {
          line: 843,
          column: 6
        },
        end: {
          line: 845,
          column: 7
        }
      },
      '382': {
        start: {
          line: 844,
          column: 8
        },
        end: {
          line: 844,
          column: 15
        }
      },
      '383': {
        start: {
          line: 846,
          column: 6
        },
        end: {
          line: 846,
          column: 30
        }
      },
      '384': {
        start: {
          line: 847,
          column: 27
        },
        end: {
          line: 849,
          column: 7
        }
      },
      '385': {
        start: {
          line: 850,
          column: 6
        },
        end: {
          line: 860,
          column: 9
        }
      },
      '386': {
        start: {
          line: 851,
          column: 8
        },
        end: {
          line: 858,
          column: 9
        }
      },
      '387': {
        start: {
          line: 852,
          column: 10
        },
        end: {
          line: 855,
          column: 13
        }
      },
      '388': {
        start: {
          line: 856,
          column: 10
        },
        end: {
          line: 856,
          column: 35
        }
      },
      '389': {
        start: {
          line: 857,
          column: 10
        },
        end: {
          line: 857,
          column: 17
        }
      },
      '390': {
        start: {
          line: 859,
          column: 8
        },
        end: {
          line: 859,
          column: 57
        }
      },
      '391': {
        start: {
          line: 864,
          column: 2
        },
        end: {
          line: 866,
          column: 4
        }
      },
      '392': {
        start: {
          line: 865,
          column: 4
        },
        end: {
          line: 865,
          column: 40
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 5,
            column: 52
          },
          end: {
            line: 5,
            column: 53
          }
        },
        loc: {
          start: {
            line: 5,
            column: 372
          },
          end: {
            line: 694,
            column: 1
          }
        },
        line: 5
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 42,
            column: 61
          },
          end: {
            line: 42,
            column: 62
          }
        },
        loc: {
          start: {
            line: 42,
            column: 69
          },
          end: {
            line: 44,
            column: 7
          }
        },
        line: 42
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 56,
            column: 23
          },
          end: {
            line: 56,
            column: 24
          }
        },
        loc: {
          start: {
            line: 56,
            column: 35
          },
          end: {
            line: 63,
            column: 3
          }
        },
        line: 56
      },
      '3': {
        name: '(anonymous_3)',
        decl: {
          start: {
            line: 84,
            column: 23
          },
          end: {
            line: 84,
            column: 24
          }
        },
        loc: {
          start: {
            line: 84,
            column: 33
          },
          end: {
            line: 92,
            column: 3
          }
        },
        line: 84
      },
      '4': {
        name: '(anonymous_4)',
        decl: {
          start: {
            line: 95,
            column: 20
          },
          end: {
            line: 95,
            column: 21
          }
        },
        loc: {
          start: {
            line: 95,
            column: 32
          },
          end: {
            line: 203,
            column: 3
          }
        },
        line: 95
      },
      '5': {
        name: '(anonymous_5)',
        decl: {
          start: {
            line: 102,
            column: 65
          },
          end: {
            line: 102,
            column: 66
          }
        },
        loc: {
          start: {
            line: 102,
            column: 74
          },
          end: {
            line: 102,
            column: 82
          }
        },
        line: 102
      },
      '6': {
        name: '(anonymous_6)',
        decl: {
          start: {
            line: 103,
            column: 65
          },
          end: {
            line: 103,
            column: 66
          }
        },
        loc: {
          start: {
            line: 103,
            column: 74
          },
          end: {
            line: 103,
            column: 82
          }
        },
        line: 103
      },
      '7': {
        name: '(anonymous_7)',
        decl: {
          start: {
            line: 178,
            column: 83
          },
          end: {
            line: 178,
            column: 84
          }
        },
        loc: {
          start: {
            line: 178,
            column: 93
          },
          end: {
            line: 199,
            column: 7
          }
        },
        line: 178
      },
      '8': {
        name: '(anonymous_8)',
        decl: {
          start: {
            line: 190,
            column: 13
          },
          end: {
            line: 190,
            column: 14
          }
        },
        loc: {
          start: {
            line: 190,
            column: 26
          },
          end: {
            line: 195,
            column: 11
          }
        },
        line: 190
      },
      '9': {
        name: '(anonymous_9)',
        decl: {
          start: {
            line: 205,
            column: 25
          },
          end: {
            line: 205,
            column: 26
          }
        },
        loc: {
          start: {
            line: 205,
            column: 49
          },
          end: {
            line: 238,
            column: 3
          }
        },
        line: 205
      },
      '10': {
        name: '(anonymous_10)',
        decl: {
          start: {
            line: 208,
            column: 108
          },
          end: {
            line: 208,
            column: 109
          }
        },
        loc: {
          start: {
            line: 208,
            column: 118
          },
          end: {
            line: 237,
            column: 5
          }
        },
        line: 208
      },
      '11': {
        name: '(anonymous_11)',
        decl: {
          start: {
            line: 227,
            column: 15
          },
          end: {
            line: 227,
            column: 16
          }
        },
        loc: {
          start: {
            line: 227,
            column: 24
          },
          end: {
            line: 231,
            column: 11
          }
        },
        line: 227
      },
      '12': {
        name: '(anonymous_12)',
        decl: {
          start: {
            line: 240,
            column: 20
          },
          end: {
            line: 240,
            column: 21
          }
        },
        loc: {
          start: {
            line: 240,
            column: 32
          },
          end: {
            line: 242,
            column: 3
          }
        },
        line: 240
      },
      '13': {
        name: '(anonymous_13)',
        decl: {
          start: {
            line: 244,
            column: 18
          },
          end: {
            line: 244,
            column: 19
          }
        },
        loc: {
          start: {
            line: 244,
            column: 36
          },
          end: {
            line: 267,
            column: 3
          }
        },
        line: 244
      },
      '14': {
        name: '(anonymous_14)',
        decl: {
          start: {
            line: 250,
            column: 78
          },
          end: {
            line: 250,
            column: 79
          }
        },
        loc: {
          start: {
            line: 250,
            column: 86
          },
          end: {
            line: 266,
            column: 5
          }
        },
        line: 250
      },
      '15': {
        name: '(anonymous_15)',
        decl: {
          start: {
            line: 269,
            column: 16
          },
          end: {
            line: 269,
            column: 17
          }
        },
        loc: {
          start: {
            line: 269,
            column: 32
          },
          end: {
            line: 436,
            column: 3
          }
        },
        line: 269
      },
      '16': {
        name: '(anonymous_16)',
        decl: {
          start: {
            line: 310,
            column: 97
          },
          end: {
            line: 310,
            column: 98
          }
        },
        loc: {
          start: {
            line: 310,
            column: 105
          },
          end: {
            line: 321,
            column: 5
          }
        },
        line: 310
      },
      '17': {
        name: '(anonymous_17)',
        decl: {
          start: {
            line: 342,
            column: 59
          },
          end: {
            line: 342,
            column: 60
          }
        },
        loc: {
          start: {
            line: 342,
            column: 68
          },
          end: {
            line: 344,
            column: 5
          }
        },
        line: 342
      },
      '18': {
        name: '(anonymous_18)',
        decl: {
          start: {
            line: 346,
            column: 60
          },
          end: {
            line: 346,
            column: 61
          }
        },
        loc: {
          start: {
            line: 346,
            column: 75
          },
          end: {
            line: 348,
            column: 5
          }
        },
        line: 346
      },
      '19': {
        name: '(anonymous_19)',
        decl: {
          start: {
            line: 387,
            column: 67
          },
          end: {
            line: 387,
            column: 68
          }
        },
        loc: {
          start: {
            line: 387,
            column: 75
          },
          end: {
            line: 389,
            column: 7
          }
        },
        line: 387
      },
      '20': {
        name: '(anonymous_20)',
        decl: {
          start: {
            line: 394,
            column: 84
          },
          end: {
            line: 394,
            column: 85
          }
        },
        loc: {
          start: {
            line: 394,
            column: 92
          },
          end: {
            line: 403,
            column: 5
          }
        },
        line: 394
      },
      '21': {
        name: '(anonymous_21)',
        decl: {
          start: {
            line: 409,
            column: 86
          },
          end: {
            line: 409,
            column: 87
          }
        },
        loc: {
          start: {
            line: 409,
            column: 94
          },
          end: {
            line: 412,
            column: 5
          }
        },
        line: 409
      },
      '22': {
        name: '(anonymous_22)',
        decl: {
          start: {
            line: 421,
            column: 62
          },
          end: {
            line: 421,
            column: 63
          }
        },
        loc: {
          start: {
            line: 421,
            column: 70
          },
          end: {
            line: 433,
            column: 5
          }
        },
        line: 421
      },
      '23': {
        name: '(anonymous_23)',
        decl: {
          start: {
            line: 438,
            column: 24
          },
          end: {
            line: 438,
            column: 25
          }
        },
        loc: {
          start: {
            line: 438,
            column: 30
          },
          end: {
            line: 460,
            column: 3
          }
        },
        line: 438
      },
      '24': {
        name: '(anonymous_24)',
        decl: {
          start: {
            line: 462,
            column: 27
          },
          end: {
            line: 462,
            column: 28
          }
        },
        loc: {
          start: {
            line: 462,
            column: 49
          },
          end: {
            line: 527,
            column: 3
          }
        },
        line: 462
      },
      '25': {
        name: '(anonymous_25)',
        decl: {
          start: {
            line: 478,
            column: 82
          },
          end: {
            line: 478,
            column: 83
          }
        },
        loc: {
          start: {
            line: 478,
            column: 90
          },
          end: {
            line: 525,
            column: 5
          }
        },
        line: 478
      },
      '26': {
        name: '(anonymous_26)',
        decl: {
          start: {
            line: 529,
            column: 27
          },
          end: {
            line: 529,
            column: 28
          }
        },
        loc: {
          start: {
            line: 529,
            column: 56
          },
          end: {
            line: 531,
            column: 3
          }
        },
        line: 529
      },
      '27': {
        name: '(anonymous_27)',
        decl: {
          start: {
            line: 533,
            column: 27
          },
          end: {
            line: 533,
            column: 28
          }
        },
        loc: {
          start: {
            line: 533,
            column: 33
          },
          end: {
            line: 555,
            column: 3
          }
        },
        line: 533
      },
      '28': {
        name: '(anonymous_28)',
        decl: {
          start: {
            line: 538,
            column: 97
          },
          end: {
            line: 538,
            column: 98
          }
        },
        loc: {
          start: {
            line: 538,
            column: 105
          },
          end: {
            line: 554,
            column: 5
          }
        },
        line: 538
      },
      '29': {
        name: '(anonymous_29)',
        decl: {
          start: {
            line: 543,
            column: 65
          },
          end: {
            line: 543,
            column: 66
          }
        },
        loc: {
          start: {
            line: 543,
            column: 74
          },
          end: {
            line: 545,
            column: 11
          }
        },
        line: 543
      },
      '30': {
        name: '(anonymous_30)',
        decl: {
          start: {
            line: 557,
            column: 18
          },
          end: {
            line: 557,
            column: 19
          }
        },
        loc: {
          start: {
            line: 557,
            column: 30
          },
          end: {
            line: 559,
            column: 3
          }
        },
        line: 557
      },
      '31': {
        name: '(anonymous_31)',
        decl: {
          start: {
            line: 561,
            column: 24
          },
          end: {
            line: 561,
            column: 25
          }
        },
        loc: {
          start: {
            line: 561,
            column: 36
          },
          end: {
            line: 583,
            column: 3
          }
        },
        line: 561
      },
      '32': {
        name: '(anonymous_32)',
        decl: {
          start: {
            line: 584,
            column: 26
          },
          end: {
            line: 584,
            column: 27
          }
        },
        loc: {
          start: {
            line: 584,
            column: 54
          },
          end: {
            line: 598,
            column: 3
          }
        },
        line: 584
      },
      '33': {
        name: '(anonymous_33)',
        decl: {
          start: {
            line: 586,
            column: 47
          },
          end: {
            line: 586,
            column: 48
          }
        },
        loc: {
          start: {
            line: 586,
            column: 57
          },
          end: {
            line: 588,
            column: 7
          }
        },
        line: 586
      },
      '34': {
        name: '(anonymous_34)',
        decl: {
          start: {
            line: 600,
            column: 22
          },
          end: {
            line: 600,
            column: 23
          }
        },
        loc: {
          start: {
            line: 600,
            column: 34
          },
          end: {
            line: 609,
            column: 3
          }
        },
        line: 600
      },
      '35': {
        name: '(anonymous_35)',
        decl: {
          start: {
            line: 610,
            column: 25
          },
          end: {
            line: 610,
            column: 26
          }
        },
        loc: {
          start: {
            line: 610,
            column: 47
          },
          end: {
            line: 625,
            column: 3
          }
        },
        line: 610
      },
      '36': {
        name: '(anonymous_36)',
        decl: {
          start: {
            line: 612,
            column: 45
          },
          end: {
            line: 612,
            column: 46
          }
        },
        loc: {
          start: {
            line: 612,
            column: 55
          },
          end: {
            line: 614,
            column: 7
          }
        },
        line: 612
      },
      '37': {
        name: '(anonymous_37)',
        decl: {
          start: {
            line: 627,
            column: 22
          },
          end: {
            line: 627,
            column: 23
          }
        },
        loc: {
          start: {
            line: 627,
            column: 38
          },
          end: {
            line: 645,
            column: 3
          }
        },
        line: 627
      },
      '38': {
        name: '(anonymous_38)',
        decl: {
          start: {
            line: 634,
            column: 75
          },
          end: {
            line: 634,
            column: 76
          }
        },
        loc: {
          start: {
            line: 634,
            column: 85
          },
          end: {
            line: 634,
            column: 97
          }
        },
        line: 634
      },
      '39': {
        name: '(anonymous_39)',
        decl: {
          start: {
            line: 647,
            column: 23
          },
          end: {
            line: 647,
            column: 24
          }
        },
        loc: {
          start: {
            line: 647,
            column: 35
          },
          end: {
            line: 686,
            column: 3
          }
        },
        line: 647
      },
      '40': {
        name: '(anonymous_40)',
        decl: {
          start: {
            line: 649,
            column: 70
          },
          end: {
            line: 649,
            column: 71
          }
        },
        loc: {
          start: {
            line: 649,
            column: 78
          },
          end: {
            line: 661,
            column: 5
          }
        },
        line: 649
      },
      '41': {
        name: '(anonymous_41)',
        decl: {
          start: {
            line: 663,
            column: 70
          },
          end: {
            line: 663,
            column: 71
          }
        },
        loc: {
          start: {
            line: 663,
            column: 78
          },
          end: {
            line: 673,
            column: 5
          }
        },
        line: 663
      },
      '42': {
        name: '(anonymous_42)',
        decl: {
          start: {
            line: 675,
            column: 57
          },
          end: {
            line: 675,
            column: 58
          }
        },
        loc: {
          start: {
            line: 675,
            column: 65
          },
          end: {
            line: 679,
            column: 5
          }
        },
        line: 675
      },
      '43': {
        name: '(anonymous_43)',
        decl: {
          start: {
            line: 681,
            column: 49
          },
          end: {
            line: 681,
            column: 50
          }
        },
        loc: {
          start: {
            line: 681,
            column: 57
          },
          end: {
            line: 684,
            column: 5
          }
        },
        line: 681
      },
      '44': {
        name: 'AgenciesCtrl_Project_edit',
        decl: {
          start: {
            line: 697,
            column: 9
          },
          end: {
            line: 697,
            column: 34
          }
        },
        loc: {
          start: {
            line: 697,
            column: 109
          },
          end: {
            line: 793,
            column: 1
          }
        },
        line: 697
      },
      '45': {
        name: '(anonymous_45)',
        decl: {
          start: {
            line: 699,
            column: 67
          },
          end: {
            line: 699,
            column: 68
          }
        },
        loc: {
          start: {
            line: 699,
            column: 78
          },
          end: {
            line: 701,
            column: 3
          }
        },
        line: 699
      },
      '46': {
        name: '(anonymous_46)',
        decl: {
          start: {
            line: 706,
            column: 22
          },
          end: {
            line: 706,
            column: 23
          }
        },
        loc: {
          start: {
            line: 706,
            column: 28
          },
          end: {
            line: 719,
            column: 3
          }
        },
        line: 706
      },
      '47': {
        name: '(anonymous_47)',
        decl: {
          start: {
            line: 721,
            column: 23
          },
          end: {
            line: 721,
            column: 24
          }
        },
        loc: {
          start: {
            line: 721,
            column: 31
          },
          end: {
            line: 731,
            column: 3
          }
        },
        line: 721
      },
      '48': {
        name: '(anonymous_48)',
        decl: {
          start: {
            line: 722,
            column: 40
          },
          end: {
            line: 722,
            column: 41
          }
        },
        loc: {
          start: {
            line: 722,
            column: 51
          },
          end: {
            line: 724,
            column: 5
          }
        },
        line: 722
      },
      '49': {
        name: '(anonymous_49)',
        decl: {
          start: {
            line: 733,
            column: 24
          },
          end: {
            line: 733,
            column: 25
          }
        },
        loc: {
          start: {
            line: 733,
            column: 36
          },
          end: {
            line: 750,
            column: 3
          }
        },
        line: 733
      },
      '50': {
        name: '(anonymous_50)',
        decl: {
          start: {
            line: 744,
            column: 90
          },
          end: {
            line: 744,
            column: 91
          }
        },
        loc: {
          start: {
            line: 744,
            column: 98
          },
          end: {
            line: 749,
            column: 5
          }
        },
        line: 744
      },
      '51': {
        name: '(anonymous_51)',
        decl: {
          start: {
            line: 752,
            column: 25
          },
          end: {
            line: 752,
            column: 26
          }
        },
        loc: {
          start: {
            line: 752,
            column: 31
          },
          end: {
            line: 754,
            column: 3
          }
        },
        line: 752
      },
      '52': {
        name: '(anonymous_52)',
        decl: {
          start: {
            line: 756,
            column: 25
          },
          end: {
            line: 756,
            column: 26
          }
        },
        loc: {
          start: {
            line: 756,
            column: 33
          },
          end: {
            line: 788,
            column: 3
          }
        },
        line: 756
      },
      '53': {
        name: '(anonymous_53)',
        decl: {
          start: {
            line: 768,
            column: 7
          },
          end: {
            line: 768,
            column: 8
          }
        },
        loc: {
          start: {
            line: 768,
            column: 20
          },
          end: {
            line: 787,
            column: 5
          }
        },
        line: 768
      },
      '54': {
        name: '(anonymous_54)',
        decl: {
          start: {
            line: 776,
            column: 70
          },
          end: {
            line: 776,
            column: 71
          }
        },
        loc: {
          start: {
            line: 776,
            column: 78
          },
          end: {
            line: 786,
            column: 7
          }
        },
        line: 776
      },
      '55': {
        name: '(anonymous_55)',
        decl: {
          start: {
            line: 790,
            column: 22
          },
          end: {
            line: 790,
            column: 23
          }
        },
        loc: {
          start: {
            line: 790,
            column: 34
          },
          end: {
            line: 792,
            column: 3
          }
        },
        line: 790
      },
      '56': {
        name: 'SectorsCtrl_Project_edit',
        decl: {
          start: {
            line: 795,
            column: 9
          },
          end: {
            line: 795,
            column: 33
          }
        },
        loc: {
          start: {
            line: 795,
            column: 108
          },
          end: {
            line: 867,
            column: 1
          }
        },
        line: 795
      },
      '57': {
        name: '(anonymous_57)',
        decl: {
          start: {
            line: 796,
            column: 21
          },
          end: {
            line: 796,
            column: 22
          }
        },
        loc: {
          start: {
            line: 796,
            column: 33
          },
          end: {
            line: 801,
            column: 3
          }
        },
        line: 796
      },
      '58': {
        name: '(anonymous_58)',
        decl: {
          start: {
            line: 803,
            column: 22
          },
          end: {
            line: 803,
            column: 23
          }
        },
        loc: {
          start: {
            line: 803,
            column: 38
          },
          end: {
            line: 806,
            column: 3
          }
        },
        line: 803
      },
      '59': {
        name: '(anonymous_59)',
        decl: {
          start: {
            line: 808,
            column: 25
          },
          end: {
            line: 808,
            column: 26
          }
        },
        loc: {
          start: {
            line: 808,
            column: 31
          },
          end: {
            line: 810,
            column: 3
          }
        },
        line: 808
      },
      '60': {
        name: '(anonymous_60)',
        decl: {
          start: {
            line: 812,
            column: 27
          },
          end: {
            line: 812,
            column: 28
          }
        },
        loc: {
          start: {
            line: 812,
            column: 33
          },
          end: {
            line: 829,
            column: 3
          }
        },
        line: 812
      },
      '61': {
        name: '(anonymous_61)',
        decl: {
          start: {
            line: 815,
            column: 30
          },
          end: {
            line: 815,
            column: 31
          }
        },
        loc: {
          start: {
            line: 815,
            column: 40
          },
          end: {
            line: 817,
            column: 5
          }
        },
        line: 815
      },
      '62': {
        name: '(anonymous_62)',
        decl: {
          start: {
            line: 822,
            column: 104
          },
          end: {
            line: 822,
            column: 105
          }
        },
        loc: {
          start: {
            line: 822,
            column: 112
          },
          end: {
            line: 828,
            column: 5
          }
        },
        line: 822
      },
      '63': {
        name: '(anonymous_63)',
        decl: {
          start: {
            line: 830,
            column: 25
          },
          end: {
            line: 830,
            column: 26
          }
        },
        loc: {
          start: {
            line: 830,
            column: 33
          },
          end: {
            line: 862,
            column: 3
          }
        },
        line: 830
      },
      '64': {
        name: '(anonymous_64)',
        decl: {
          start: {
            line: 842,
            column: 7
          },
          end: {
            line: 842,
            column: 8
          }
        },
        loc: {
          start: {
            line: 842,
            column: 20
          },
          end: {
            line: 861,
            column: 5
          }
        },
        line: 842
      },
      '65': {
        name: '(anonymous_65)',
        decl: {
          start: {
            line: 850,
            column: 67
          },
          end: {
            line: 850,
            column: 68
          }
        },
        loc: {
          start: {
            line: 850,
            column: 75
          },
          end: {
            line: 860,
            column: 7
          }
        },
        line: 850
      },
      '66': {
        name: '(anonymous_66)',
        decl: {
          start: {
            line: 864,
            column: 22
          },
          end: {
            line: 864,
            column: 23
          }
        },
        loc: {
          start: {
            line: 864,
            column: 34
          },
          end: {
            line: 866,
            column: 3
          }
        },
        line: 864
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 59,
            column: 16
          },
          end: {
            line: 59,
            column: 75
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 59,
            column: 16
          },
          end: {
            line: 59,
            column: 51
          }
        }, {
          start: {
            line: 59,
            column: 55
          },
          end: {
            line: 59,
            column: 75
          }
        }],
        line: 59
      },
      '1': {
        loc: {
          start: {
            line: 85,
            column: 4
          },
          end: {
            line: 87,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 85,
            column: 4
          },
          end: {
            line: 87,
            column: 5
          }
        }, {
          start: {
            line: 85,
            column: 4
          },
          end: {
            line: 87,
            column: 5
          }
        }],
        line: 85
      },
      '2': {
        loc: {
          start: {
            line: 88,
            column: 4
          },
          end: {
            line: 90,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 88,
            column: 4
          },
          end: {
            line: 90,
            column: 5
          }
        }, {
          start: {
            line: 88,
            column: 4
          },
          end: {
            line: 90,
            column: 5
          }
        }],
        line: 88
      },
      '3': {
        loc: {
          start: {
            line: 104,
            column: 33
          },
          end: {
            line: 104,
            column: 112
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 104,
            column: 107
          },
          end: {
            line: 104,
            column: 108
          }
        }, {
          start: {
            line: 104,
            column: 111
          },
          end: {
            line: 104,
            column: 112
          }
        }],
        line: 104
      },
      '4': {
        loc: {
          start: {
            line: 104,
            column: 34
          },
          end: {
            line: 104,
            column: 103
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 104,
            column: 34
          },
          end: {
            line: 104,
            column: 66
          }
        }, {
          start: {
            line: 104,
            column: 70
          },
          end: {
            line: 104,
            column: 103
          }
        }],
        line: 104
      },
      '5': {
        loc: {
          start: {
            line: 107,
            column: 30
          },
          end: {
            line: 107,
            column: 73
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 107,
            column: 30
          },
          end: {
            line: 107,
            column: 59
          }
        }, {
          start: {
            line: 107,
            column: 63
          },
          end: {
            line: 107,
            column: 73
          }
        }],
        line: 107
      },
      '6': {
        loc: {
          start: {
            line: 108,
            column: 31
          },
          end: {
            line: 108,
            column: 70
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 108,
            column: 65
          },
          end: {
            line: 108,
            column: 66
          }
        }, {
          start: {
            line: 108,
            column: 69
          },
          end: {
            line: 108,
            column: 70
          }
        }],
        line: 108
      },
      '7': {
        loc: {
          start: {
            line: 109,
            column: 32
          },
          end: {
            line: 109,
            column: 72
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 109,
            column: 67
          },
          end: {
            line: 109,
            column: 68
          }
        }, {
          start: {
            line: 109,
            column: 71
          },
          end: {
            line: 109,
            column: 72
          }
        }],
        line: 109
      },
      '8': {
        loc: {
          start: {
            line: 110,
            column: 35
          },
          end: {
            line: 110,
            column: 78
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 110,
            column: 73
          },
          end: {
            line: 110,
            column: 74
          }
        }, {
          start: {
            line: 110,
            column: 77
          },
          end: {
            line: 110,
            column: 78
          }
        }],
        line: 110
      },
      '9': {
        loc: {
          start: {
            line: 111,
            column: 32
          },
          end: {
            line: 111,
            column: 72
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 111,
            column: 67
          },
          end: {
            line: 111,
            column: 68
          }
        }, {
          start: {
            line: 111,
            column: 71
          },
          end: {
            line: 111,
            column: 72
          }
        }],
        line: 111
      },
      '10': {
        loc: {
          start: {
            line: 112,
            column: 27
          },
          end: {
            line: 112,
            column: 62
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 112,
            column: 57
          },
          end: {
            line: 112,
            column: 58
          }
        }, {
          start: {
            line: 112,
            column: 61
          },
          end: {
            line: 112,
            column: 62
          }
        }],
        line: 112
      },
      '11': {
        loc: {
          start: {
            line: 118,
            column: 9
          },
          end: {
            line: 118,
            column: 47
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 118,
            column: 38
          },
          end: {
            line: 118,
            column: 41
          }
        }, {
          start: {
            line: 118,
            column: 44
          },
          end: {
            line: 118,
            column: 47
          }
        }],
        line: 118
      },
      '12': {
        loc: {
          start: {
            line: 119,
            column: 10
          },
          end: {
            line: 119,
            column: 49
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 119,
            column: 40
          },
          end: {
            line: 119,
            column: 43
          }
        }, {
          start: {
            line: 119,
            column: 46
          },
          end: {
            line: 119,
            column: 49
          }
        }],
        line: 119
      },
      '13': {
        loc: {
          start: {
            line: 120,
            column: 10
          },
          end: {
            line: 120,
            column: 49
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 120,
            column: 40
          },
          end: {
            line: 120,
            column: 43
          }
        }, {
          start: {
            line: 120,
            column: 46
          },
          end: {
            line: 120,
            column: 49
          }
        }],
        line: 120
      },
      '14': {
        loc: {
          start: {
            line: 121,
            column: 10
          },
          end: {
            line: 121,
            column: 49
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 121,
            column: 40
          },
          end: {
            line: 121,
            column: 43
          }
        }, {
          start: {
            line: 121,
            column: 46
          },
          end: {
            line: 121,
            column: 49
          }
        }],
        line: 121
      },
      '15': {
        loc: {
          start: {
            line: 122,
            column: 9
          },
          end: {
            line: 122,
            column: 47
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 122,
            column: 38
          },
          end: {
            line: 122,
            column: 41
          }
        }, {
          start: {
            line: 122,
            column: 44
          },
          end: {
            line: 122,
            column: 47
          }
        }],
        line: 122
      },
      '16': {
        loc: {
          start: {
            line: 123,
            column: 10
          },
          end: {
            line: 123,
            column: 49
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 123,
            column: 40
          },
          end: {
            line: 123,
            column: 43
          }
        }, {
          start: {
            line: 123,
            column: 46
          },
          end: {
            line: 123,
            column: 49
          }
        }],
        line: 123
      },
      '17': {
        loc: {
          start: {
            line: 124,
            column: 10
          },
          end: {
            line: 124,
            column: 49
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 124,
            column: 40
          },
          end: {
            line: 124,
            column: 43
          }
        }, {
          start: {
            line: 124,
            column: 46
          },
          end: {
            line: 124,
            column: 49
          }
        }],
        line: 124
      },
      '18': {
        loc: {
          start: {
            line: 125,
            column: 10
          },
          end: {
            line: 125,
            column: 49
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 125,
            column: 40
          },
          end: {
            line: 125,
            column: 43
          }
        }, {
          start: {
            line: 125,
            column: 46
          },
          end: {
            line: 125,
            column: 49
          }
        }],
        line: 125
      },
      '19': {
        loc: {
          start: {
            line: 126,
            column: 10
          },
          end: {
            line: 126,
            column: 49
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 126,
            column: 40
          },
          end: {
            line: 126,
            column: 43
          }
        }, {
          start: {
            line: 126,
            column: 46
          },
          end: {
            line: 126,
            column: 49
          }
        }],
        line: 126
      },
      '20': {
        loc: {
          start: {
            line: 135,
            column: 6
          },
          end: {
            line: 145,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 135,
            column: 6
          },
          end: {
            line: 145,
            column: 7
          }
        }, {
          start: {
            line: 135,
            column: 6
          },
          end: {
            line: 145,
            column: 7
          }
        }],
        line: 135
      },
      '21': {
        loc: {
          start: {
            line: 137,
            column: 8
          },
          end: {
            line: 144,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 137,
            column: 8
          },
          end: {
            line: 144,
            column: 9
          }
        }, {
          start: {
            line: 137,
            column: 8
          },
          end: {
            line: 144,
            column: 9
          }
        }],
        line: 137
      },
      '22': {
        loc: {
          start: {
            line: 137,
            column: 12
          },
          end: {
            line: 137,
            column: 80
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 137,
            column: 12
          },
          end: {
            line: 137,
            column: 38
          }
        }, {
          start: {
            line: 137,
            column: 42
          },
          end: {
            line: 137,
            column: 80
          }
        }],
        line: 137
      },
      '23': {
        loc: {
          start: {
            line: 147,
            column: 4
          },
          end: {
            line: 154,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 147,
            column: 4
          },
          end: {
            line: 154,
            column: 5
          }
        }, {
          start: {
            line: 147,
            column: 4
          },
          end: {
            line: 154,
            column: 5
          }
        }],
        line: 147
      },
      '24': {
        loc: {
          start: {
            line: 155,
            column: 4
          },
          end: {
            line: 162,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 155,
            column: 4
          },
          end: {
            line: 162,
            column: 5
          }
        }, {
          start: {
            line: 155,
            column: 4
          },
          end: {
            line: 162,
            column: 5
          }
        }],
        line: 155
      },
      '25': {
        loc: {
          start: {
            line: 176,
            column: 4
          },
          end: {
            line: 202,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 176,
            column: 4
          },
          end: {
            line: 202,
            column: 5
          }
        }, {
          start: {
            line: 176,
            column: 4
          },
          end: {
            line: 202,
            column: 5
          }
        }],
        line: 176
      },
      '26': {
        loc: {
          start: {
            line: 176,
            column: 8
          },
          end: {
            line: 176,
            column: 115
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 176,
            column: 8
          },
          end: {
            line: 176,
            column: 59
          }
        }, {
          start: {
            line: 176,
            column: 63
          },
          end: {
            line: 176,
            column: 83
          }
        }, {
          start: {
            line: 176,
            column: 87
          },
          end: {
            line: 176,
            column: 115
          }
        }],
        line: 176
      },
      '27': {
        loc: {
          start: {
            line: 179,
            column: 8
          },
          end: {
            line: 198,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 179,
            column: 8
          },
          end: {
            line: 198,
            column: 9
          }
        }, {
          start: {
            line: 179,
            column: 8
          },
          end: {
            line: 198,
            column: 9
          }
        }],
        line: 179
      },
      '28': {
        loc: {
          start: {
            line: 191,
            column: 12
          },
          end: {
            line: 193,
            column: 13
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 191,
            column: 12
          },
          end: {
            line: 193,
            column: 13
          }
        }, {
          start: {
            line: 191,
            column: 12
          },
          end: {
            line: 193,
            column: 13
          }
        }],
        line: 191
      },
      '29': {
        loc: {
          start: {
            line: 210,
            column: 6
          },
          end: {
            line: 233,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 210,
            column: 6
          },
          end: {
            line: 233,
            column: 7
          }
        }, {
          start: {
            line: 210,
            column: 6
          },
          end: {
            line: 233,
            column: 7
          }
        }],
        line: 210
      },
      '30': {
        loc: {
          start: {
            line: 214,
            column: 25
          },
          end: {
            line: 214,
            column: 54
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 214,
            column: 25
          },
          end: {
            line: 214,
            column: 48
          }
        }, {
          start: {
            line: 214,
            column: 52
          },
          end: {
            line: 214,
            column: 54
          }
        }],
        line: 214
      },
      '31': {
        loc: {
          start: {
            line: 219,
            column: 30
          },
          end: {
            line: 219,
            column: 55
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 219,
            column: 50
          },
          end: {
            line: 219,
            column: 51
          }
        }, {
          start: {
            line: 219,
            column: 54
          },
          end: {
            line: 219,
            column: 55
          }
        }],
        line: 219
      },
      '32': {
        loc: {
          start: {
            line: 228,
            column: 12
          },
          end: {
            line: 230,
            column: 13
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 228,
            column: 12
          },
          end: {
            line: 230,
            column: 13
          }
        }, {
          start: {
            line: 228,
            column: 12
          },
          end: {
            line: 230,
            column: 13
          }
        }],
        line: 228
      },
      '33': {
        loc: {
          start: {
            line: 278,
            column: 8
          },
          end: {
            line: 281,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 278,
            column: 8
          },
          end: {
            line: 281,
            column: 9
          }
        }, {
          start: {
            line: 278,
            column: 8
          },
          end: {
            line: 281,
            column: 9
          }
        }],
        line: 278
      },
      '34': {
        loc: {
          start: {
            line: 331,
            column: 89
          },
          end: {
            line: 331,
            column: 116
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 331,
            column: 89
          },
          end: {
            line: 331,
            column: 109
          }
        }, {
          start: {
            line: 331,
            column: 113
          },
          end: {
            line: 331,
            column: 116
          }
        }],
        line: 331
      },
      '35': {
        loc: {
          start: {
            line: 332,
            column: 76
          },
          end: {
            line: 332,
            column: 106
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 332,
            column: 76
          },
          end: {
            line: 332,
            column: 101
          }
        }, {
          start: {
            line: 332,
            column: 105
          },
          end: {
            line: 332,
            column: 106
          }
        }],
        line: 332
      },
      '36': {
        loc: {
          start: {
            line: 335,
            column: 4
          },
          end: {
            line: 337,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 335,
            column: 4
          },
          end: {
            line: 337,
            column: 5
          }
        }, {
          start: {
            line: 335,
            column: 4
          },
          end: {
            line: 337,
            column: 5
          }
        }],
        line: 335
      },
      '37': {
        loc: {
          start: {
            line: 335,
            column: 8
          },
          end: {
            line: 335,
            column: 97
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 335,
            column: 8
          },
          end: {
            line: 335,
            column: 25
          }
        }, {
          start: {
            line: 335,
            column: 29
          },
          end: {
            line: 335,
            column: 52
          }
        }, {
          start: {
            line: 335,
            column: 56
          },
          end: {
            line: 335,
            column: 97
          }
        }],
        line: 335
      },
      '38': {
        loc: {
          start: {
            line: 340,
            column: 92
          },
          end: {
            line: 340,
            column: 113
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 340,
            column: 92
          },
          end: {
            line: 340,
            column: 108
          }
        }, {
          start: {
            line: 340,
            column: 112
          },
          end: {
            line: 340,
            column: 113
          }
        }],
        line: 340
      },
      '39': {
        loc: {
          start: {
            line: 369,
            column: 44
          },
          end: {
            line: 369,
            column: 62
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 369,
            column: 44
          },
          end: {
            line: 369,
            column: 55
          }
        }, {
          start: {
            line: 369,
            column: 59
          },
          end: {
            line: 369,
            column: 62
          }
        }],
        line: 369
      },
      '40': {
        loc: {
          start: {
            line: 370,
            column: 46
          },
          end: {
            line: 370,
            column: 66
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 370,
            column: 46
          },
          end: {
            line: 370,
            column: 59
          }
        }, {
          start: {
            line: 370,
            column: 63
          },
          end: {
            line: 370,
            column: 66
          }
        }],
        line: 370
      },
      '41': {
        loc: {
          start: {
            line: 376,
            column: 6
          },
          end: {
            line: 378,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 376,
            column: 6
          },
          end: {
            line: 378,
            column: 7
          }
        }, {
          start: {
            line: 376,
            column: 6
          },
          end: {
            line: 378,
            column: 7
          }
        }],
        line: 376
      },
      '42': {
        loc: {
          start: {
            line: 381,
            column: 6
          },
          end: {
            line: 383,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 381,
            column: 6
          },
          end: {
            line: 383,
            column: 7
          }
        }, {
          start: {
            line: 381,
            column: 6
          },
          end: {
            line: 383,
            column: 7
          }
        }],
        line: 381
      },
      '43': {
        loc: {
          start: {
            line: 386,
            column: 4
          },
          end: {
            line: 392,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 386,
            column: 4
          },
          end: {
            line: 392,
            column: 5
          }
        }, {
          start: {
            line: 386,
            column: 4
          },
          end: {
            line: 392,
            column: 5
          }
        }],
        line: 386
      },
      '44': {
        loc: {
          start: {
            line: 414,
            column: 4
          },
          end: {
            line: 418,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 414,
            column: 4
          },
          end: {
            line: 418,
            column: 5
          }
        }, {
          start: {
            line: 414,
            column: 4
          },
          end: {
            line: 418,
            column: 5
          }
        }],
        line: 414
      },
      '45': {
        loc: {
          start: {
            line: 421,
            column: 47
          },
          end: {
            line: 421,
            column: 59
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 421,
            column: 47
          },
          end: {
            line: 421,
            column: 54
          }
        }, {
          start: {
            line: 421,
            column: 58
          },
          end: {
            line: 421,
            column: 59
          }
        }],
        line: 421
      },
      '46': {
        loc: {
          start: {
            line: 423,
            column: 8
          },
          end: {
            line: 425,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 423,
            column: 8
          },
          end: {
            line: 425,
            column: 9
          }
        }, {
          start: {
            line: 423,
            column: 8
          },
          end: {
            line: 425,
            column: 9
          }
        }],
        line: 423
      },
      '47': {
        loc: {
          start: {
            line: 426,
            column: 8
          },
          end: {
            line: 428,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 426,
            column: 8
          },
          end: {
            line: 428,
            column: 9
          }
        }, {
          start: {
            line: 426,
            column: 8
          },
          end: {
            line: 428,
            column: 9
          }
        }],
        line: 426
      },
      '48': {
        loc: {
          start: {
            line: 439,
            column: 4
          },
          end: {
            line: 441,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 439,
            column: 4
          },
          end: {
            line: 441,
            column: 5
          }
        }, {
          start: {
            line: 439,
            column: 4
          },
          end: {
            line: 441,
            column: 5
          }
        }],
        line: 439
      },
      '49': {
        loc: {
          start: {
            line: 467,
            column: 4
          },
          end: {
            line: 476,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 467,
            column: 4
          },
          end: {
            line: 476,
            column: 5
          }
        }, {
          start: {
            line: 467,
            column: 4
          },
          end: {
            line: 476,
            column: 5
          }
        }],
        line: 467
      },
      '50': {
        loc: {
          start: {
            line: 468,
            column: 6
          },
          end: {
            line: 472,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 468,
            column: 6
          },
          end: {
            line: 472,
            column: 7
          }
        }, {
          start: {
            line: 468,
            column: 6
          },
          end: {
            line: 472,
            column: 7
          }
        }],
        line: 468
      },
      '51': {
        loc: {
          start: {
            line: 473,
            column: 6
          },
          end: {
            line: 475,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 473,
            column: 6
          },
          end: {
            line: 475,
            column: 7
          }
        }, {
          start: {
            line: 473,
            column: 6
          },
          end: {
            line: 475,
            column: 7
          }
        }],
        line: 473
      },
      '52': {
        loc: {
          start: {
            line: 473,
            column: 10
          },
          end: {
            line: 473,
            column: 73
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 473,
            column: 10
          },
          end: {
            line: 473,
            column: 40
          }
        }, {
          start: {
            line: 473,
            column: 44
          },
          end: {
            line: 473,
            column: 73
          }
        }],
        line: 473
      },
      '53': {
        loc: {
          start: {
            line: 478,
            column: 58
          },
          end: {
            line: 478,
            column: 75
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 478,
            column: 58
          },
          end: {
            line: 478,
            column: 67
          }
        }, {
          start: {
            line: 478,
            column: 71
          },
          end: {
            line: 478,
            column: 75
          }
        }],
        line: 478
      },
      '54': {
        loc: {
          start: {
            line: 479,
            column: 6
          },
          end: {
            line: 482,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 479,
            column: 6
          },
          end: {
            line: 482,
            column: 7
          }
        }, {
          start: {
            line: 479,
            column: 6
          },
          end: {
            line: 482,
            column: 7
          }
        }],
        line: 479
      },
      '55': {
        loc: {
          start: {
            line: 484,
            column: 8
          },
          end: {
            line: 486,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 484,
            column: 8
          },
          end: {
            line: 486,
            column: 9
          }
        }, {
          start: {
            line: 484,
            column: 8
          },
          end: {
            line: 486,
            column: 9
          }
        }],
        line: 484
      },
      '56': {
        loc: {
          start: {
            line: 492,
            column: 43
          },
          end: {
            line: 492,
            column: 75
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 492,
            column: 43
          },
          end: {
            line: 492,
            column: 62
          }
        }, {
          start: {
            line: 492,
            column: 66
          },
          end: {
            line: 492,
            column: 75
          }
        }],
        line: 492
      },
      '57': {
        loc: {
          start: {
            line: 495,
            column: 8
          },
          end: {
            line: 497,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 495,
            column: 8
          },
          end: {
            line: 497,
            column: 9
          }
        }, {
          start: {
            line: 495,
            column: 8
          },
          end: {
            line: 497,
            column: 9
          }
        }],
        line: 495
      },
      '58': {
        loc: {
          start: {
            line: 498,
            column: 8
          },
          end: {
            line: 500,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 498,
            column: 8
          },
          end: {
            line: 500,
            column: 9
          }
        }, {
          start: {
            line: 498,
            column: 8
          },
          end: {
            line: 500,
            column: 9
          }
        }],
        line: 498
      },
      '59': {
        loc: {
          start: {
            line: 519,
            column: 6
          },
          end: {
            line: 524,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 519,
            column: 6
          },
          end: {
            line: 524,
            column: 7
          }
        }, {
          start: {
            line: 519,
            column: 6
          },
          end: {
            line: 524,
            column: 7
          }
        }],
        line: 519
      },
      '60': {
        loc: {
          start: {
            line: 529,
            column: 34
          },
          end: {
            line: 529,
            column: 51
          }
        },
        type: 'default-arg',
        locations: [{
          start: {
            line: 529,
            column: 46
          },
          end: {
            line: 529,
            column: 51
          }
        }],
        line: 529
      },
      '61': {
        loc: {
          start: {
            line: 530,
            column: 78
          },
          end: {
            line: 530,
            column: 123
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 530,
            column: 90
          },
          end: {
            line: 530,
            column: 104
          }
        }, {
          start: {
            line: 530,
            column: 107
          },
          end: {
            line: 530,
            column: 123
          }
        }],
        line: 530
      },
      '62': {
        loc: {
          start: {
            line: 541,
            column: 6
          },
          end: {
            line: 551,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 541,
            column: 6
          },
          end: {
            line: 551,
            column: 7
          }
        }, {
          start: {
            line: 541,
            column: 6
          },
          end: {
            line: 551,
            column: 7
          }
        }],
        line: 541
      },
      '63': {
        loc: {
          start: {
            line: 542,
            column: 8
          },
          end: {
            line: 546,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 542,
            column: 8
          },
          end: {
            line: 546,
            column: 9
          }
        }, {
          start: {
            line: 542,
            column: 8
          },
          end: {
            line: 546,
            column: 9
          }
        }],
        line: 542
      },
      '64': {
        loc: {
          start: {
            line: 548,
            column: 8
          },
          end: {
            line: 550,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 548,
            column: 8
          },
          end: {
            line: 550,
            column: 9
          }
        }, {
          start: {
            line: 548,
            column: 8
          },
          end: {
            line: 550,
            column: 9
          }
        }],
        line: 548
      },
      '65': {
        loc: {
          start: {
            line: 585,
            column: 4
          },
          end: {
            line: 590,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 585,
            column: 4
          },
          end: {
            line: 590,
            column: 5
          }
        }, {
          start: {
            line: 585,
            column: 4
          },
          end: {
            line: 590,
            column: 5
          }
        }],
        line: 585
      },
      '66': {
        loc: {
          start: {
            line: 592,
            column: 6
          },
          end: {
            line: 595,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 592,
            column: 6
          },
          end: {
            line: 595,
            column: 7
          }
        }, {
          start: {
            line: 592,
            column: 6
          },
          end: {
            line: 595,
            column: 7
          }
        }],
        line: 592
      },
      '67': {
        loc: {
          start: {
            line: 611,
            column: 4
          },
          end: {
            line: 616,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 611,
            column: 4
          },
          end: {
            line: 616,
            column: 5
          }
        }, {
          start: {
            line: 611,
            column: 4
          },
          end: {
            line: 616,
            column: 5
          }
        }],
        line: 611
      },
      '68': {
        loc: {
          start: {
            line: 618,
            column: 6
          },
          end: {
            line: 622,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 618,
            column: 6
          },
          end: {
            line: 622,
            column: 7
          }
        }, {
          start: {
            line: 618,
            column: 6
          },
          end: {
            line: 622,
            column: 7
          }
        }],
        line: 618
      },
      '69': {
        loc: {
          start: {
            line: 634,
            column: 19
          },
          end: {
            line: 634,
            column: 50
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 634,
            column: 19
          },
          end: {
            line: 634,
            column: 44
          }
        }, {
          start: {
            line: 634,
            column: 48
          },
          end: {
            line: 634,
            column: 50
          }
        }],
        line: 634
      },
      '70': {
        loc: {
          start: {
            line: 650,
            column: 6
          },
          end: {
            line: 660,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 650,
            column: 6
          },
          end: {
            line: 660,
            column: 7
          }
        }, {
          start: {
            line: 650,
            column: 6
          },
          end: {
            line: 660,
            column: 7
          }
        }],
        line: 650
      },
      '71': {
        loc: {
          start: {
            line: 664,
            column: 6
          },
          end: {
            line: 672,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 664,
            column: 6
          },
          end: {
            line: 672,
            column: 7
          }
        }, {
          start: {
            line: 664,
            column: 6
          },
          end: {
            line: 672,
            column: 7
          }
        }],
        line: 664
      },
      '72': {
        loc: {
          start: {
            line: 726,
            column: 4
          },
          end: {
            line: 728,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 726,
            column: 4
          },
          end: {
            line: 728,
            column: 5
          }
        }, {
          start: {
            line: 726,
            column: 4
          },
          end: {
            line: 728,
            column: 5
          }
        }],
        line: 726
      },
      '73': {
        loc: {
          start: {
            line: 738,
            column: 6
          },
          end: {
            line: 741,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 738,
            column: 6
          },
          end: {
            line: 741,
            column: 7
          }
        }, {
          start: {
            line: 738,
            column: 6
          },
          end: {
            line: 741,
            column: 7
          }
        }],
        line: 738
      },
      '74': {
        loc: {
          start: {
            line: 738,
            column: 10
          },
          end: {
            line: 738,
            column: 44
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 738,
            column: 10
          },
          end: {
            line: 738,
            column: 14
          }
        }, {
          start: {
            line: 738,
            column: 18
          },
          end: {
            line: 738,
            column: 44
          }
        }],
        line: 738
      },
      '75': {
        loc: {
          start: {
            line: 769,
            column: 6
          },
          end: {
            line: 771,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 769,
            column: 6
          },
          end: {
            line: 771,
            column: 7
          }
        }, {
          start: {
            line: 769,
            column: 6
          },
          end: {
            line: 771,
            column: 7
          }
        }],
        line: 769
      },
      '76': {
        loc: {
          start: {
            line: 777,
            column: 8
          },
          end: {
            line: 784,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 777,
            column: 8
          },
          end: {
            line: 784,
            column: 9
          }
        }, {
          start: {
            line: 777,
            column: 8
          },
          end: {
            line: 784,
            column: 9
          }
        }],
        line: 777
      },
      '77': {
        loc: {
          start: {
            line: 815,
            column: 4
          },
          end: {
            line: 820,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 815,
            column: 4
          },
          end: {
            line: 820,
            column: 5
          }
        }, {
          start: {
            line: 815,
            column: 4
          },
          end: {
            line: 820,
            column: 5
          }
        }],
        line: 815
      },
      '78': {
        loc: {
          start: {
            line: 816,
            column: 13
          },
          end: {
            line: 816,
            column: 124
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 816,
            column: 13
          },
          end: {
            line: 816,
            column: 83
          }
        }, {
          start: {
            line: 816,
            column: 87
          },
          end: {
            line: 816,
            column: 124
          }
        }],
        line: 816
      },
      '79': {
        loc: {
          start: {
            line: 843,
            column: 6
          },
          end: {
            line: 845,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 843,
            column: 6
          },
          end: {
            line: 845,
            column: 7
          }
        }, {
          start: {
            line: 843,
            column: 6
          },
          end: {
            line: 845,
            column: 7
          }
        }],
        line: 843
      },
      '80': {
        loc: {
          start: {
            line: 851,
            column: 8
          },
          end: {
            line: 858,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 851,
            column: 8
          },
          end: {
            line: 858,
            column: 9
          }
        }, {
          start: {
            line: 851,
            column: 8
          },
          end: {
            line: 858,
            column: 9
          }
        }],
        line: 851
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0,
      '31': 0,
      '32': 0,
      '33': 0,
      '34': 0,
      '35': 0,
      '36': 0,
      '37': 0,
      '38': 0,
      '39': 0,
      '40': 0,
      '41': 0,
      '42': 0,
      '43': 0,
      '44': 0,
      '45': 0,
      '46': 0,
      '47': 0,
      '48': 0,
      '49': 0,
      '50': 0,
      '51': 0,
      '52': 0,
      '53': 0,
      '54': 0,
      '55': 0,
      '56': 0,
      '57': 0,
      '58': 0,
      '59': 0,
      '60': 0,
      '61': 0,
      '62': 0,
      '63': 0,
      '64': 0,
      '65': 0,
      '66': 0,
      '67': 0,
      '68': 0,
      '69': 0,
      '70': 0,
      '71': 0,
      '72': 0,
      '73': 0,
      '74': 0,
      '75': 0,
      '76': 0,
      '77': 0,
      '78': 0,
      '79': 0,
      '80': 0,
      '81': 0,
      '82': 0,
      '83': 0,
      '84': 0,
      '85': 0,
      '86': 0,
      '87': 0,
      '88': 0,
      '89': 0,
      '90': 0,
      '91': 0,
      '92': 0,
      '93': 0,
      '94': 0,
      '95': 0,
      '96': 0,
      '97': 0,
      '98': 0,
      '99': 0,
      '100': 0,
      '101': 0,
      '102': 0,
      '103': 0,
      '104': 0,
      '105': 0,
      '106': 0,
      '107': 0,
      '108': 0,
      '109': 0,
      '110': 0,
      '111': 0,
      '112': 0,
      '113': 0,
      '114': 0,
      '115': 0,
      '116': 0,
      '117': 0,
      '118': 0,
      '119': 0,
      '120': 0,
      '121': 0,
      '122': 0,
      '123': 0,
      '124': 0,
      '125': 0,
      '126': 0,
      '127': 0,
      '128': 0,
      '129': 0,
      '130': 0,
      '131': 0,
      '132': 0,
      '133': 0,
      '134': 0,
      '135': 0,
      '136': 0,
      '137': 0,
      '138': 0,
      '139': 0,
      '140': 0,
      '141': 0,
      '142': 0,
      '143': 0,
      '144': 0,
      '145': 0,
      '146': 0,
      '147': 0,
      '148': 0,
      '149': 0,
      '150': 0,
      '151': 0,
      '152': 0,
      '153': 0,
      '154': 0,
      '155': 0,
      '156': 0,
      '157': 0,
      '158': 0,
      '159': 0,
      '160': 0,
      '161': 0,
      '162': 0,
      '163': 0,
      '164': 0,
      '165': 0,
      '166': 0,
      '167': 0,
      '168': 0,
      '169': 0,
      '170': 0,
      '171': 0,
      '172': 0,
      '173': 0,
      '174': 0,
      '175': 0,
      '176': 0,
      '177': 0,
      '178': 0,
      '179': 0,
      '180': 0,
      '181': 0,
      '182': 0,
      '183': 0,
      '184': 0,
      '185': 0,
      '186': 0,
      '187': 0,
      '188': 0,
      '189': 0,
      '190': 0,
      '191': 0,
      '192': 0,
      '193': 0,
      '194': 0,
      '195': 0,
      '196': 0,
      '197': 0,
      '198': 0,
      '199': 0,
      '200': 0,
      '201': 0,
      '202': 0,
      '203': 0,
      '204': 0,
      '205': 0,
      '206': 0,
      '207': 0,
      '208': 0,
      '209': 0,
      '210': 0,
      '211': 0,
      '212': 0,
      '213': 0,
      '214': 0,
      '215': 0,
      '216': 0,
      '217': 0,
      '218': 0,
      '219': 0,
      '220': 0,
      '221': 0,
      '222': 0,
      '223': 0,
      '224': 0,
      '225': 0,
      '226': 0,
      '227': 0,
      '228': 0,
      '229': 0,
      '230': 0,
      '231': 0,
      '232': 0,
      '233': 0,
      '234': 0,
      '235': 0,
      '236': 0,
      '237': 0,
      '238': 0,
      '239': 0,
      '240': 0,
      '241': 0,
      '242': 0,
      '243': 0,
      '244': 0,
      '245': 0,
      '246': 0,
      '247': 0,
      '248': 0,
      '249': 0,
      '250': 0,
      '251': 0,
      '252': 0,
      '253': 0,
      '254': 0,
      '255': 0,
      '256': 0,
      '257': 0,
      '258': 0,
      '259': 0,
      '260': 0,
      '261': 0,
      '262': 0,
      '263': 0,
      '264': 0,
      '265': 0,
      '266': 0,
      '267': 0,
      '268': 0,
      '269': 0,
      '270': 0,
      '271': 0,
      '272': 0,
      '273': 0,
      '274': 0,
      '275': 0,
      '276': 0,
      '277': 0,
      '278': 0,
      '279': 0,
      '280': 0,
      '281': 0,
      '282': 0,
      '283': 0,
      '284': 0,
      '285': 0,
      '286': 0,
      '287': 0,
      '288': 0,
      '289': 0,
      '290': 0,
      '291': 0,
      '292': 0,
      '293': 0,
      '294': 0,
      '295': 0,
      '296': 0,
      '297': 0,
      '298': 0,
      '299': 0,
      '300': 0,
      '301': 0,
      '302': 0,
      '303': 0,
      '304': 0,
      '305': 0,
      '306': 0,
      '307': 0,
      '308': 0,
      '309': 0,
      '310': 0,
      '311': 0,
      '312': 0,
      '313': 0,
      '314': 0,
      '315': 0,
      '316': 0,
      '317': 0,
      '318': 0,
      '319': 0,
      '320': 0,
      '321': 0,
      '322': 0,
      '323': 0,
      '324': 0,
      '325': 0,
      '326': 0,
      '327': 0,
      '328': 0,
      '329': 0,
      '330': 0,
      '331': 0,
      '332': 0,
      '333': 0,
      '334': 0,
      '335': 0,
      '336': 0,
      '337': 0,
      '338': 0,
      '339': 0,
      '340': 0,
      '341': 0,
      '342': 0,
      '343': 0,
      '344': 0,
      '345': 0,
      '346': 0,
      '347': 0,
      '348': 0,
      '349': 0,
      '350': 0,
      '351': 0,
      '352': 0,
      '353': 0,
      '354': 0,
      '355': 0,
      '356': 0,
      '357': 0,
      '358': 0,
      '359': 0,
      '360': 0,
      '361': 0,
      '362': 0,
      '363': 0,
      '364': 0,
      '365': 0,
      '366': 0,
      '367': 0,
      '368': 0,
      '369': 0,
      '370': 0,
      '371': 0,
      '372': 0,
      '373': 0,
      '374': 0,
      '375': 0,
      '376': 0,
      '377': 0,
      '378': 0,
      '379': 0,
      '380': 0,
      '381': 0,
      '382': 0,
      '383': 0,
      '384': 0,
      '385': 0,
      '386': 0,
      '387': 0,
      '388': 0,
      '389': 0,
      '390': 0,
      '391': 0,
      '392': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0,
      '31': 0,
      '32': 0,
      '33': 0,
      '34': 0,
      '35': 0,
      '36': 0,
      '37': 0,
      '38': 0,
      '39': 0,
      '40': 0,
      '41': 0,
      '42': 0,
      '43': 0,
      '44': 0,
      '45': 0,
      '46': 0,
      '47': 0,
      '48': 0,
      '49': 0,
      '50': 0,
      '51': 0,
      '52': 0,
      '53': 0,
      '54': 0,
      '55': 0,
      '56': 0,
      '57': 0,
      '58': 0,
      '59': 0,
      '60': 0,
      '61': 0,
      '62': 0,
      '63': 0,
      '64': 0,
      '65': 0,
      '66': 0
    },
    b: {
      '0': [0, 0],
      '1': [0, 0],
      '2': [0, 0],
      '3': [0, 0],
      '4': [0, 0],
      '5': [0, 0],
      '6': [0, 0],
      '7': [0, 0],
      '8': [0, 0],
      '9': [0, 0],
      '10': [0, 0],
      '11': [0, 0],
      '12': [0, 0],
      '13': [0, 0],
      '14': [0, 0],
      '15': [0, 0],
      '16': [0, 0],
      '17': [0, 0],
      '18': [0, 0],
      '19': [0, 0],
      '20': [0, 0],
      '21': [0, 0],
      '22': [0, 0],
      '23': [0, 0],
      '24': [0, 0],
      '25': [0, 0],
      '26': [0, 0, 0],
      '27': [0, 0],
      '28': [0, 0],
      '29': [0, 0],
      '30': [0, 0],
      '31': [0, 0],
      '32': [0, 0],
      '33': [0, 0],
      '34': [0, 0],
      '35': [0, 0],
      '36': [0, 0],
      '37': [0, 0, 0],
      '38': [0, 0],
      '39': [0, 0],
      '40': [0, 0],
      '41': [0, 0],
      '42': [0, 0],
      '43': [0, 0],
      '44': [0, 0],
      '45': [0, 0],
      '46': [0, 0],
      '47': [0, 0],
      '48': [0, 0],
      '49': [0, 0],
      '50': [0, 0],
      '51': [0, 0],
      '52': [0, 0],
      '53': [0, 0],
      '54': [0, 0],
      '55': [0, 0],
      '56': [0, 0],
      '57': [0, 0],
      '58': [0, 0],
      '59': [0, 0],
      '60': [0],
      '61': [0, 0],
      '62': [0, 0],
      '63': [0, 0],
      '64': [0, 0],
      '65': [0, 0],
      '66': [0, 0],
      '67': [0, 0],
      '68': [0, 0],
      '69': [0, 0],
      '70': [0, 0],
      '71': [0, 0],
      '72': [0, 0],
      '73': [0, 0],
      '74': [0, 0],
      '75': [0, 0],
      '76': [0, 0],
      '77': [0, 0],
      '78': [0, 0],
      '79': [0, 0],
      '80': [0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

cov_1n0vzmhyuy.s[0]++;

angular.module('app').controller('ProjectEditCtrl', function ($scope, $stateParams, $deltaclearData, $state, $timeout, $LOGINService, $deltaPlanLogique, $deltaNumber, $deltaLocation, $log, $deltaGeoData, $deltaDefaultTemplate, SweetAlert, $rootScope, $deltadate, $translate, $CRUDService, $otherHttpService, $deltahttp, $location, $filter, FileUploader, $http, $uibModal, $sce) {
  cov_1n0vzmhyuy.f[0]++;


  var PATH = (cov_1n0vzmhyuy.s[1]++, 'Milestone');
  var KEY_PROJECT_MAP_CENTER = (cov_1n0vzmhyuy.s[2]++, 'PROJECT_MAP_CENTER');
  var KEY_PROJECT_MAP_DEPTH = (cov_1n0vzmhyuy.s[3]++, 'PROJECT_MAP_DEPTH');
  var PATH_INDICATEUR = (cov_1n0vzmhyuy.s[4]++, 'IndicateursGlobal');
  var PATH_CUSTOM_FIELDS = (cov_1n0vzmhyuy.s[5]++, 'CustomFields');

  var KEY_VIEW_ACTIVITIES = (cov_1n0vzmhyuy.s[6]++, 'KEY_VIEW_ACTIVITIES_PARAMS');
  var KEY_DISPLAY_LIST = (cov_1n0vzmhyuy.s[7]++, 'KEY_DISPLAY_LIST_PROJECT');
  cov_1n0vzmhyuy.s[8]++;
  $scope.PATH = 'Projet';
  var currentDate = (cov_1n0vzmhyuy.s[9]++, new Date());

  cov_1n0vzmhyuy.s[10]++;
  $scope.isadd = true;
  cov_1n0vzmhyuy.s[11]++;
  $scope.isloading = false;

  cov_1n0vzmhyuy.s[12]++;
  $scope.selectedProjet = $rootScope.currentProject.project;
  cov_1n0vzmhyuy.s[13]++;
  $scope.selectedItem = $rootScope.currentProject.project;

  cov_1n0vzmhyuy.s[14]++;
  $scope.autoCompleteGroupOptions = null;

  cov_1n0vzmhyuy.s[15]++;
  $scope.typeList = [{ id: 1, name: $translate.instant('PROJECT.TYPES.PROJECT') }, { id: 2, name: $translate.instant('PROJECT.TYPES.PROGRAM') }, { id: 3, name: $translate.instant('PROJECT.TYPES.OTHER') }];

  cov_1n0vzmhyuy.s[16]++;
  $scope.statutsList = [{ id: 1, name: $translate.instant('PROJECT.STATUTS.NOT_STARTED'), class: 'label-success' }, { id: 2, name: $translate.instant('PROJECT.STATUTS.ACTIVE'), class: 'label-primary' }, { id: 3, name: $translate.instant('PROJECT.STATUTS.SUSPENDED'), class: 'label-danger' }, { id: 4, name: $translate.instant('PROJECT.STATUTS.COMPLETED'), class: 'label-default' }, { id: 5, name: $translate.instant('PROJECT.STATUTS.ARCHIVED'), class: 'label-default' }];
  cov_1n0vzmhyuy.s[17]++;
  $scope.filter = {
    financialSourcesList: [],
    getAllFinancialSource: function getAllFinancialSource() {
      var _this = this;

      cov_1n0vzmhyuy.s[18]++;

      $CRUDService.getAll($scope.PATH, { get: 'fin_sources' }, function (data) {
        cov_1n0vzmhyuy.f[1]++;
        cov_1n0vzmhyuy.s[19]++;

        _this.financialSourcesList = data;
      });
    }
  };

  cov_1n0vzmhyuy.s[20]++;
  $scope.listMonths = $deltadate.getPeriods(Date.newDate('1989-01-01'), Date.newDate('1989-12-31'), 12, false, 1);
  cov_1n0vzmhyuy.s[21]++;

  $scope.listMilestone = [];
  cov_1n0vzmhyuy.s[22]++;
  $scope.listProjects = [];

  cov_1n0vzmhyuy.s[23]++;
  $scope.contries = [{ id: 1, name: $translate.instant('COUNTRIES.AF') }, { id: 2, name: $translate.instant('COUNTRIES.AX') }, { id: 3, name: $translate.instant('COUNTRIES.AL') }, { id: 4, name: $translate.instant('COUNTRIES.DZ') }, { id: 5, name: $translate.instant('COUNTRIES.AS') }, { id: 6, name: $translate.instant('COUNTRIES.AD') }, { id: 7, name: $translate.instant('COUNTRIES.AO') }, { id: 8, name: $translate.instant('COUNTRIES.AI') }, { id: 9, name: $translate.instant('COUNTRIES.AQ') }, { id: 10, name: $translate.instant('COUNTRIES.AG') }, { id: 11, name: $translate.instant('COUNTRIES.AR') }, { id: 12, name: $translate.instant('COUNTRIES.AM') }, { id: 13, name: $translate.instant('COUNTRIES.AW') }, { id: 14, name: $translate.instant('COUNTRIES.AU') }, { id: 15, name: $translate.instant('COUNTRIES.AT') }, { id: 16, name: $translate.instant('COUNTRIES.AZ') }, { id: 17, name: $translate.instant('COUNTRIES.BS') }, { id: 18, name: $translate.instant('COUNTRIES.BH') }, { id: 19, name: $translate.instant('COUNTRIES.BD') }, { id: 20, name: $translate.instant('COUNTRIES.BB') }, { id: 21, name: $translate.instant('COUNTRIES.BY') }, { id: 22, name: $translate.instant('COUNTRIES.BE') }, { id: 23, name: $translate.instant('COUNTRIES.BZ') }, { id: 24, name: $translate.instant('COUNTRIES.BJ') }, { id: 25, name: $translate.instant('COUNTRIES.BM') }, { id: 26, name: $translate.instant('COUNTRIES.BT') }, { id: 27, name: $translate.instant('COUNTRIES.BO') }, { id: 28, name: $translate.instant('COUNTRIES.BA') }, { id: 29, name: $translate.instant('COUNTRIES.BW') }, { id: 30, name: $translate.instant('COUNTRIES.BV') }, { id: 31, name: $translate.instant('COUNTRIES.BR') }, { id: 32, name: $translate.instant('COUNTRIES.IO') }, { id: 33, name: $translate.instant('COUNTRIES.BN') }, { id: 34, name: $translate.instant('COUNTRIES.BG') }, { id: 35, name: $translate.instant('COUNTRIES.BF') }, { id: 36, name: $translate.instant('COUNTRIES.BI') }, { id: 37, name: $translate.instant('COUNTRIES.KH') }, { id: 38, name: $translate.instant('COUNTRIES.CM') }, { id: 39, name: $translate.instant('COUNTRIES.CA') }, { id: 40, name: $translate.instant('COUNTRIES.CV') }, { id: 41, name: $translate.instant('COUNTRIES.KY') }, { id: 42, name: $translate.instant('COUNTRIES.CF') }, { id: 43, name: $translate.instant('COUNTRIES.TD') }, { id: 44, name: $translate.instant('COUNTRIES.CL') }, { id: 45, name: $translate.instant('COUNTRIES.CN') }, { id: 46, name: $translate.instant('COUNTRIES.CX') }, { id: 47, name: $translate.instant('COUNTRIES.CC') }, { id: 48, name: $translate.instant('COUNTRIES.CO') }, { id: 49, name: $translate.instant('COUNTRIES.KM') }, { id: 50, name: $translate.instant('COUNTRIES.CG') }, { id: 51, name: $translate.instant('COUNTRIES.CD') }, { id: 52, name: $translate.instant('COUNTRIES.CK') }, { id: 53, name: $translate.instant('COUNTRIES.CR') }, { id: 54, name: $translate.instant('COUNTRIES.CI') }, { id: 55, name: $translate.instant('COUNTRIES.HR') }, { id: 56, name: $translate.instant('COUNTRIES.CU') }, { id: 57, name: $translate.instant('COUNTRIES.CY') }, { id: 58, name: $translate.instant('COUNTRIES.CZ') }, { id: 59, name: $translate.instant('COUNTRIES.DK') }, { id: 60, name: $translate.instant('COUNTRIES.DJ') }, { id: 61, name: $translate.instant('COUNTRIES.DM') }, { id: 62, name: $translate.instant('COUNTRIES.DO') }, { id: 63, name: $translate.instant('COUNTRIES.EC') }, { id: 64, name: $translate.instant('COUNTRIES.EG') }, { id: 65, name: $translate.instant('COUNTRIES.SV') }, { id: 66, name: $translate.instant('COUNTRIES.GQ') }, { id: 67, name: $translate.instant('COUNTRIES.ER') }, { id: 68, name: $translate.instant('COUNTRIES.EE') }, { id: 69, name: $translate.instant('COUNTRIES.ET') }, { id: 70, name: $translate.instant('COUNTRIES.FK') }, { id: 71, name: $translate.instant('COUNTRIES.FO') }, { id: 72, name: $translate.instant('COUNTRIES.FJ') }, { id: 73, name: $translate.instant('COUNTRIES.FI') }, { id: 74, name: $translate.instant('COUNTRIES.FR') }, { id: 75, name: $translate.instant('COUNTRIES.GF') }, { id: 76, name: $translate.instant('COUNTRIES.PF') }, { id: 77, name: $translate.instant('COUNTRIES.TF') }, { id: 78, name: $translate.instant('COUNTRIES.GA') }, { id: 79, name: $translate.instant('COUNTRIES.GM') }, { id: 80, name: $translate.instant('COUNTRIES.GE') }, { id: 81, name: $translate.instant('COUNTRIES.DE') }, { id: 82, name: $translate.instant('COUNTRIES.GH') }, { id: 83, name: $translate.instant('COUNTRIES.GI') }, { id: 84, name: $translate.instant('COUNTRIES.GR') }, { id: 85, name: $translate.instant('COUNTRIES.GL') }, { id: 86, name: $translate.instant('COUNTRIES.GD') }, { id: 87, name: $translate.instant('COUNTRIES.GP') }, { id: 88, name: $translate.instant('COUNTRIES.GU') }, { id: 89, name: $translate.instant('COUNTRIES.GT') }, { id: 90, name: $translate.instant('COUNTRIES.GG') }, { id: 91, name: $translate.instant('COUNTRIES.GN') }, { id: 92, name: $translate.instant('COUNTRIES.GW') }, { id: 93, name: $translate.instant('COUNTRIES.GY') }, { id: 94, name: $translate.instant('COUNTRIES.HT') }, { id: 95, name: $translate.instant('COUNTRIES.HM') }, { id: 96, name: $translate.instant('COUNTRIES.VA') }, { id: 97, name: $translate.instant('COUNTRIES.HN') }, { id: 98, name: $translate.instant('COUNTRIES.HK') }, { id: 99, name: $translate.instant('COUNTRIES.HU') }, { id: 100, name: $translate.instant('COUNTRIES.IS') }, { id: 101, name: $translate.instant('COUNTRIES.IN') }, { id: 102, name: $translate.instant('COUNTRIES.ID') }, { id: 103, name: $translate.instant('COUNTRIES.IR') }, { id: 104, name: $translate.instant('COUNTRIES.IQ') }, { id: 105, name: $translate.instant('COUNTRIES.IE') }, { id: 106, name: $translate.instant('COUNTRIES.IM') }, { id: 107, name: $translate.instant('COUNTRIES.IL') }, { id: 108, name: $translate.instant('COUNTRIES.IT') }, { id: 109, name: $translate.instant('COUNTRIES.JM') }, { id: 110, name: $translate.instant('COUNTRIES.JP') }, { id: 111, name: $translate.instant('COUNTRIES.JE') }, { id: 112, name: $translate.instant('COUNTRIES.JO') }, { id: 113, name: $translate.instant('COUNTRIES.KZ') }, { id: 114, name: $translate.instant('COUNTRIES.KE') }, { id: 115, name: $translate.instant('COUNTRIES.KI') }, { id: 116, name: $translate.instant('COUNTRIES.KP') }, { id: 117, name: $translate.instant('COUNTRIES.KR') }, { id: 118, name: $translate.instant('COUNTRIES.KW') }, { id: 119, name: $translate.instant('COUNTRIES.KG') }, { id: 120, name: $translate.instant('COUNTRIES.LA') }, { id: 121, name: $translate.instant('COUNTRIES.LV') }, { id: 122, name: $translate.instant('COUNTRIES.LB') }, { id: 123, name: $translate.instant('COUNTRIES.LS') }, { id: 124, name: $translate.instant('COUNTRIES.LR') }, { id: 125, name: $translate.instant('COUNTRIES.LY') }, { id: 126, name: $translate.instant('COUNTRIES.LI') }, { id: 127, name: $translate.instant('COUNTRIES.LT') }, { id: 128, name: $translate.instant('COUNTRIES.LU') }, { id: 129, name: $translate.instant('COUNTRIES.MO') }, { id: 130, name: $translate.instant('COUNTRIES.MK') }, { id: 131, name: $translate.instant('COUNTRIES.MG') }, { id: 132, name: $translate.instant('COUNTRIES.MW') }, { id: 133, name: $translate.instant('COUNTRIES.MY') }, { id: 134, name: $translate.instant('COUNTRIES.MV') }, { id: 135, name: $translate.instant('COUNTRIES.ML') }, { id: 136, name: $translate.instant('COUNTRIES.MT') }, { id: 137, name: $translate.instant('COUNTRIES.MH') }, { id: 138, name: $translate.instant('COUNTRIES.MQ') }, { id: 139, name: $translate.instant('COUNTRIES.MR') }, { id: 140, name: $translate.instant('COUNTRIES.MU') }, { id: 141, name: $translate.instant('COUNTRIES.YT') }, { id: 142, name: $translate.instant('COUNTRIES.MX') }, { id: 143, name: $translate.instant('COUNTRIES.FM') }, { id: 144, name: $translate.instant('COUNTRIES.MD') }, { id: 145, name: $translate.instant('COUNTRIES.MC') }, { id: 146, name: $translate.instant('COUNTRIES.MN') }, { id: 147, name: $translate.instant('COUNTRIES.MS') }, { id: 148, name: $translate.instant('COUNTRIES.MA') }, { id: 149, name: $translate.instant('COUNTRIES.MZ') }, { id: 150, name: $translate.instant('COUNTRIES.MM') }, { id: 151, name: $translate.instant('COUNTRIES.NA') }, { id: 152, name: $translate.instant('COUNTRIES.NR') }, { id: 153, name: $translate.instant('COUNTRIES.NP') }, { id: 154, name: $translate.instant('COUNTRIES.NL') }, { id: 155, name: $translate.instant('COUNTRIES.AN') }, { id: 156, name: $translate.instant('COUNTRIES.NC') }, { id: 157, name: $translate.instant('COUNTRIES.NZ') }, { id: 158, name: $translate.instant('COUNTRIES.NI') }, { id: 159, name: $translate.instant('COUNTRIES.NE') }, { id: 160, name: $translate.instant('COUNTRIES.NG') }, { id: 161, name: $translate.instant('COUNTRIES.NU') }, { id: 162, name: $translate.instant('COUNTRIES.NF') }, { id: 163, name: $translate.instant('COUNTRIES.MP') }, { id: 164, name: $translate.instant('COUNTRIES.NO') }, { id: 165, name: $translate.instant('COUNTRIES.OM') }, { id: 166, name: $translate.instant('COUNTRIES.PK') }, { id: 167, name: $translate.instant('COUNTRIES.PW') }, { id: 168, name: $translate.instant('COUNTRIES.PS') }, { id: 169, name: $translate.instant('COUNTRIES.PA') }, { id: 170, name: $translate.instant('COUNTRIES.PG') }, { id: 171, name: $translate.instant('COUNTRIES.PY') }, { id: 172, name: $translate.instant('COUNTRIES.PE') }, { id: 173, name: $translate.instant('COUNTRIES.PH') }, { id: 174, name: $translate.instant('COUNTRIES.PN') }, { id: 175, name: $translate.instant('COUNTRIES.PL') }, { id: 176, name: $translate.instant('COUNTRIES.PT') }, { id: 177, name: $translate.instant('COUNTRIES.PR') }, { id: 178, name: $translate.instant('COUNTRIES.QA') }, { id: 179, name: $translate.instant('COUNTRIES.RE') }, { id: 180, name: $translate.instant('COUNTRIES.RO') }, { id: 181, name: $translate.instant('COUNTRIES.RU') }, { id: 182, name: $translate.instant('COUNTRIES.RW') }, { id: 183, name: $translate.instant('COUNTRIES.SH') }, { id: 184, name: $translate.instant('COUNTRIES.KN') }, { id: 185, name: $translate.instant('COUNTRIES.LC') }, { id: 186, name: $translate.instant('COUNTRIES.PM') }, { id: 187, name: $translate.instant('COUNTRIES.VC') }, { id: 188, name: $translate.instant('COUNTRIES.WS') }, { id: 189, name: $translate.instant('COUNTRIES.SM') }, { id: 190, name: $translate.instant('COUNTRIES.ST') }, { id: 191, name: $translate.instant('COUNTRIES.SA') }, { id: 192, name: $translate.instant('COUNTRIES.SN') }, { id: 193, name: $translate.instant('COUNTRIES.CS') }, { id: 194, name: $translate.instant('COUNTRIES.SC') }, { id: 195, name: $translate.instant('COUNTRIES.SL') }, { id: 196, name: $translate.instant('COUNTRIES.SG') }, { id: 197, name: $translate.instant('COUNTRIES.SK') }, { id: 198, name: $translate.instant('COUNTRIES.SI') }, { id: 199, name: $translate.instant('COUNTRIES.SB') }, { id: 200, name: $translate.instant('COUNTRIES.SO') }, { id: 201, name: $translate.instant('COUNTRIES.ZA') }, { id: 202, name: $translate.instant('COUNTRIES.GS') }, { id: 203, name: $translate.instant('COUNTRIES.ES') }, { id: 204, name: $translate.instant('COUNTRIES.LK') }, { id: 205, name: $translate.instant('COUNTRIES.SD') }, { id: 206, name: $translate.instant('COUNTRIES.SR') }, { id: 207, name: $translate.instant('COUNTRIES.SJ') }, { id: 208, name: $translate.instant('COUNTRIES.SZ') }, { id: 209, name: $translate.instant('COUNTRIES.SE') }, { id: 210, name: $translate.instant('COUNTRIES.CH') }, { id: 211, name: $translate.instant('COUNTRIES.SY') }, { id: 212, name: $translate.instant('COUNTRIES.TW') }, { id: 213, name: $translate.instant('COUNTRIES.TJ') }, { id: 214, name: $translate.instant('COUNTRIES.TZ') }, { id: 215, name: $translate.instant('COUNTRIES.TH') }, { id: 216, name: $translate.instant('COUNTRIES.TL') }, { id: 217, name: $translate.instant('COUNTRIES.TG') }, { id: 218, name: $translate.instant('COUNTRIES.TK') }, { id: 219, name: $translate.instant('COUNTRIES.TO') }, { id: 220, name: $translate.instant('COUNTRIES.TT') }, { id: 221, name: $translate.instant('COUNTRIES.TN') }, { id: 222, name: $translate.instant('COUNTRIES.TR') }, { id: 223, name: $translate.instant('COUNTRIES.TM') }, { id: 224, name: $translate.instant('COUNTRIES.TC') }, { id: 225, name: $translate.instant('COUNTRIES.TV') }, { id: 226, name: $translate.instant('COUNTRIES.UG') }, { id: 227, name: $translate.instant('COUNTRIES.UA') }, { id: 228, name: $translate.instant('COUNTRIES.AE') }, { id: 229, name: $translate.instant('COUNTRIES.GB') }, { id: 230, name: $translate.instant('COUNTRIES.US') }, { id: 231, name: $translate.instant('COUNTRIES.UM') }, { id: 232, name: $translate.instant('COUNTRIES.UY') }, { id: 233, name: $translate.instant('COUNTRIES.UZ') }, { id: 234, name: $translate.instant('COUNTRIES.VU') }, { id: 235, name: $translate.instant('COUNTRIES.VE') }, { id: 236, name: $translate.instant('COUNTRIES.VN') }, { id: 237, name: $translate.instant('COUNTRIES.VG') }, { id: 238, name: $translate.instant('COUNTRIES.VI') }, { id: 239, name: $translate.instant('COUNTRIES.WF') }, { id: 240, name: $translate.instant('COUNTRIES.EH') }, { id: 241, name: $translate.instant('COUNTRIES.YE') }, { id: 242, name: $translate.instant('COUNTRIES.ZM') }, { id: 243, name: $translate.instant('COUNTRIES.ZW') }];
  cov_1n0vzmhyuy.s[24]++;
  $scope.changeMonth = function () {
    cov_1n0vzmhyuy.f[2]++;
    cov_1n0vzmhyuy.s[25]++;

    $scope.listFiscalYears = $deltadate.getPeriods($scope.selectedItem.DATE_DEB_PROJET, $scope.selectedItem.DATE_FIN_PROJET, 1, false, $scope.selectedItem.START_MONTH.index);
    cov_1n0vzmhyuy.s[26]++;
    for (var _iterator = $scope.listFiscalYears, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
      var _ref;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref = _i.value;
      }

      var year = _ref;

      var _ = (cov_1n0vzmhyuy.s[27]++, (cov_1n0vzmhyuy.b[0][0]++, $scope.listPeriodCutting[year.year]) || (cov_1n0vzmhyuy.b[0][1]++, { id: 0, period: '0' }));
      cov_1n0vzmhyuy.s[28]++;
      year.id = _.id;
      cov_1n0vzmhyuy.s[29]++;
      year.period = $filter('filter')($scope.listPeriodicity, { id: _.period }, true)[0];
    }
  };
  cov_1n0vzmhyuy.s[30]++;
  $scope.listPeriodicity = [{
    label: $translate.instant('COMMON.YEAR'),
    id: '1'
  }, {
    label: $translate.instant('COMMON.SEM'),
    id: '2'
  }, {
    label: $translate.instant('COMMON.TRIM'),
    id: '4'
  }, {
    label: $translate.instant('COMMON.MOIS'),
    id: '12'
  }, {
    label: '',
    id: '0'
  }];

  cov_1n0vzmhyuy.s[31]++;
  $scope.contries.sort(function (a, b) {
    cov_1n0vzmhyuy.f[3]++;
    cov_1n0vzmhyuy.s[32]++;

    if (a.name > b.name) {
      cov_1n0vzmhyuy.b[1][0]++;
      cov_1n0vzmhyuy.s[33]++;

      return 1;
    } else {
      cov_1n0vzmhyuy.b[1][1]++;
    }
    cov_1n0vzmhyuy.s[34]++;
    if (a.name < b.name) {
      cov_1n0vzmhyuy.b[2][0]++;
      cov_1n0vzmhyuy.s[35]++;

      return -1;
    } else {
      cov_1n0vzmhyuy.b[2][1]++;
    }
    cov_1n0vzmhyuy.s[36]++;
    return 0;
  });

  cov_1n0vzmhyuy.s[37]++;
  $scope.validate = function () {
    cov_1n0vzmhyuy.f[4]++;

    var validateItem = (cov_1n0vzmhyuy.s[38]++, angular.copy($scope.selectedItem));
    cov_1n0vzmhyuy.s[39]++;
    validateItem.DATE_DEB_PROJET = $deltadate.format($scope.selectedItem.DATE_DEB_PROJET, 'dd/mm/yyyy');
    cov_1n0vzmhyuy.s[40]++;
    validateItem.DATE_FIN_PROJET = $deltadate.format($scope.selectedItem.DATE_FIN_PROJET, 'dd/mm/yyyy');
    cov_1n0vzmhyuy.s[41]++;
    validateItem.DATE_MI_PRO = $deltadate.format($scope.selectedItem.DATE_MI_PRO, 'yyyy-mm-dd');
    cov_1n0vzmhyuy.s[42]++;
    validateItem.PAYS_PROJET = 0;cov_1n0vzmhyuy.s[43]++;

    validateItem.ID_AGENCY = 0;cov_1n0vzmhyuy.s[44]++;

    validateItem.IDS_AGENCY = $scope.selectedItem.IDS_AGENCY.map(function (value) {
      cov_1n0vzmhyuy.f[5]++;
      cov_1n0vzmhyuy.s[45]++;
      return value.id;
    });
    cov_1n0vzmhyuy.s[46]++;
    validateItem.IDS_SECTOR = $scope.selectedItem.IDS_SECTOR.map(function (value) {
      cov_1n0vzmhyuy.f[6]++;
      cov_1n0vzmhyuy.s[47]++;
      return value.id;
    });
    cov_1n0vzmhyuy.s[48]++;
    validateItem.STATUT_BUDGET = (cov_1n0vzmhyuy.b[4][0]++, $scope.selectedItem.DISPLAY_DATA) && (cov_1n0vzmhyuy.b[4][1]++, $scope.selectedItem.STATUT_BUDGET) ? (cov_1n0vzmhyuy.b[3][0]++, 1) : (cov_1n0vzmhyuy.b[3][1]++, 0);
    cov_1n0vzmhyuy.s[49]++;
    validateItem.STATUS = $scope.selectedItem.STATUS.id;
    cov_1n0vzmhyuy.s[50]++;
    validateItem.TYPE_PROJECT = $scope.selectedItem.TYPE_PROJECT.id;
    cov_1n0vzmhyuy.s[51]++;
    validateItem.IDACTEURS = ((cov_1n0vzmhyuy.b[5][0]++, $scope.selectedItem.IDACTEURS) || (cov_1n0vzmhyuy.b[5][1]++, { id: -100 })).id;
    cov_1n0vzmhyuy.s[52]++;
    validateItem.GLOBAL_PLAN = $scope.selectedItem.GLOBAL_PLAN ? (cov_1n0vzmhyuy.b[6][0]++, 1) : (cov_1n0vzmhyuy.b[6][1]++, 0);
    cov_1n0vzmhyuy.s[53]++;
    validateItem.CUSTOM_FIELD = $scope.selectedItem.CUSTOM_FIELD ? (cov_1n0vzmhyuy.b[7][0]++, 1) : (cov_1n0vzmhyuy.b[7][1]++, 0);
    cov_1n0vzmhyuy.s[54]++;
    validateItem.ACTIVITY_WEIGHT = $scope.selectedItem.ACTIVITY_WEIGHT ? (cov_1n0vzmhyuy.b[8][0]++, 1) : (cov_1n0vzmhyuy.b[8][1]++, 0);
    cov_1n0vzmhyuy.s[55]++;
    validateItem.DISPLAY_DATA = $scope.selectedItem.DISPLAY_DATA ? (cov_1n0vzmhyuy.b[9][0]++, 1) : (cov_1n0vzmhyuy.b[9][1]++, 0);
    cov_1n0vzmhyuy.s[56]++;
    validateItem.LINK_PG = $scope.selectedItem.LINK_PG ? (cov_1n0vzmhyuy.b[10][0]++, 1) : (cov_1n0vzmhyuy.b[10][1]++, 0);
    cov_1n0vzmhyuy.s[57]++;
    validateItem.PERIODIC_FOLLOW = 1;cov_1n0vzmhyuy.s[58]++;

    validateItem.ME_METHOD = 2;cov_1n0vzmhyuy.s[59]++;

    validateItem.START_MONTH = $scope.selectedItem.START_MONTH.index;
    cov_1n0vzmhyuy.s[60]++;
    validateItem.LINK = {
      U: $scope.selectedItem.LINK.U ? (cov_1n0vzmhyuy.b[11][0]++, '1') : (cov_1n0vzmhyuy.b[11][1]++, '0'),
      SF: $scope.selectedItem.LINK.SF ? (cov_1n0vzmhyuy.b[12][0]++, '1') : (cov_1n0vzmhyuy.b[12][1]++, '0'),
      PG: $scope.selectedItem.LINK.PG ? (cov_1n0vzmhyuy.b[13][0]++, '1') : (cov_1n0vzmhyuy.b[13][1]++, '0'),
      PL: $scope.selectedItem.LINK.PL ? (cov_1n0vzmhyuy.b[14][0]++, '1') : (cov_1n0vzmhyuy.b[14][1]++, '0'),
      F: $scope.selectedItem.LINK.F ? (cov_1n0vzmhyuy.b[15][0]++, '1') : (cov_1n0vzmhyuy.b[15][1]++, '0'),
      TA: $scope.selectedItem.LINK.TA ? (cov_1n0vzmhyuy.b[16][0]++, '1') : (cov_1n0vzmhyuy.b[16][1]++, '0'),
      TI: $scope.selectedItem.LINK.TI ? (cov_1n0vzmhyuy.b[17][0]++, '1') : (cov_1n0vzmhyuy.b[17][1]++, '0'),
      TR: $scope.selectedItem.LINK.TR ? (cov_1n0vzmhyuy.b[18][0]++, '1') : (cov_1n0vzmhyuy.b[18][1]++, '0'),
      FR: $scope.selectedItem.LINK.FR ? (cov_1n0vzmhyuy.b[19][0]++, '1') : (cov_1n0vzmhyuy.b[19][1]++, '0')
    };
    cov_1n0vzmhyuy.s[61]++;
    $scope.error = {
      id: 0,
      label: null
    };
    cov_1n0vzmhyuy.s[62]++;

    for (var i = 0; i < $scope.listProjects.length; i++) {
      var item = (cov_1n0vzmhyuy.s[63]++, $scope.listProjects[i]);
      cov_1n0vzmhyuy.s[64]++;
      if ($scope.listProjects[i].id == item.id) {
        cov_1n0vzmhyuy.b[20][0]++;
        cov_1n0vzmhyuy.s[65]++;

        if ((cov_1n0vzmhyuy.b[22][0]++, item.id != validateItem.id) && (cov_1n0vzmhyuy.b[22][1]++, validateItem.CODE_PRJ == item.CODE_PRJ)) {
          cov_1n0vzmhyuy.b[21][0]++;
          cov_1n0vzmhyuy.s[66]++;

          $scope.error = {
            id: 1,
            label: 'PROJECT.ERROR.DBL'
          };
          cov_1n0vzmhyuy.s[67]++;
          $scope.edit.tab = 1;
          cov_1n0vzmhyuy.s[68]++;
          return;
        } else {
          cov_1n0vzmhyuy.b[21][1]++;
        }
      } else {
        cov_1n0vzmhyuy.b[20][1]++;
      }
    }
    cov_1n0vzmhyuy.s[69]++;
    if ($scope.selectedItem.DATE_DEB_PROJET > $scope.selectedItem.DATE_FIN_PROJET) {
      cov_1n0vzmhyuy.b[23][0]++;
      cov_1n0vzmhyuy.s[70]++;

      $scope.error = {
        id: 2,
        label: 'PROJECT.ERROR.DATE'
      };
      cov_1n0vzmhyuy.s[71]++;
      $scope.edit.tab = 1;
      cov_1n0vzmhyuy.s[72]++;
      return;
    } else {
      cov_1n0vzmhyuy.b[23][1]++;
    }
    cov_1n0vzmhyuy.s[73]++;
    if (validateItem.Format_cout.length > 5) {
      cov_1n0vzmhyuy.b[24][0]++;
      cov_1n0vzmhyuy.s[74]++;

      $scope.error = {
        id: 3,
        label: 'PROJECT.ERROR.CURRENCY'
      };
      cov_1n0vzmhyuy.s[75]++;
      $scope.edit.tab = 1;
      cov_1n0vzmhyuy.s[76]++;
      return;
    } else {
      cov_1n0vzmhyuy.b[24][1]++;
    }
    cov_1n0vzmhyuy.s[77]++;


    if ((cov_1n0vzmhyuy.b[26][0]++, $scope.LAST_START_MONTH != validateItem.START_MONTH) && (cov_1n0vzmhyuy.b[26][1]++, validateItem.id != 0) && (cov_1n0vzmhyuy.b[26][2]++, $scope.locks.start_month > 0)) {
      cov_1n0vzmhyuy.b[25][0]++;
      cov_1n0vzmhyuy.s[78]++;

      $CRUDService.getAll($scope.PATH, { get: 'check_fiscal', id: validateItem.id }, function (data__) {
        cov_1n0vzmhyuy.f[7]++;
        cov_1n0vzmhyuy.s[79]++;

        if (parseInt(data__, 10) > 0) {
          cov_1n0vzmhyuy.b[27][0]++;
          cov_1n0vzmhyuy.s[80]++;

          SweetAlert.swal({
            title: '',
            text: $translate.instant('PROJECT.ERROR.SAVING'),
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55', cancelButtonColor: '#c8c8c8',
            confirmButtonText: $translate.instant('COMMON.CANCEL'),
            cancelButtonText: $translate.instant('COMMON.CONTINUE'),
            closeOnConfirm: true,
            closeOnCancel: true
          }, function (isconfirm) {
            cov_1n0vzmhyuy.f[8]++;
            cov_1n0vzmhyuy.s[81]++;

            if (isconfirm) {
              cov_1n0vzmhyuy.b[28][0]++;
              cov_1n0vzmhyuy.s[82]++;

              return;
            } else {
              cov_1n0vzmhyuy.b[28][1]++;
            }
            cov_1n0vzmhyuy.s[83]++;
            $scope.__saveProject(validateItem);
          });
        } else {
          cov_1n0vzmhyuy.b[27][1]++;
          cov_1n0vzmhyuy.s[84]++;

          $scope.__saveProject(validateItem);
        }
      });
    } else {
      cov_1n0vzmhyuy.b[25][1]++;
      cov_1n0vzmhyuy.s[85]++;

      $scope.__saveProject(validateItem);
    }
  };

  cov_1n0vzmhyuy.s[86]++;
  $scope.__saveProject = function (validateItem) {
    cov_1n0vzmhyuy.f[9]++;

    var valueP = (cov_1n0vzmhyuy.s[87]++, $filter('json')(validateItem, 3));
    cov_1n0vzmhyuy.s[88]++;
    $scope.isloading = true;
    cov_1n0vzmhyuy.s[89]++;
    $CRUDService.save($scope.PATH, { action: 'miseAJourAdmin', valeur: validateItem }, function (result) {
      cov_1n0vzmhyuy.f[10]++;

      var data = (cov_1n0vzmhyuy.s[90]++, parseInt(result, 10));
      cov_1n0vzmhyuy.s[91]++;
      if (data > 0) {
        cov_1n0vzmhyuy.b[29][0]++;
        cov_1n0vzmhyuy.s[92]++;

        for (var _iterator2 = $scope.addingSource, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
          var _ref2;

          if (_isArray2) {
            if (_i2 >= _iterator2.length) break;
            _ref2 = _iterator2[_i2++];
          } else {
            _i2 = _iterator2.next();
            if (_i2.done) break;
            _ref2 = _i2.value;
          }

          var source = _ref2;
          cov_1n0vzmhyuy.s[93]++;

          $CRUDService.save('Financement', { action: 'MiseAJourProjet', valeur: $filter('json')(source), id: data });
        }
        cov_1n0vzmhyuy.s[94]++;
        for (var _iterator3 = (cov_1n0vzmhyuy.b[30][0]++, $scope.deletedMilestone) || (cov_1n0vzmhyuy.b[30][1]++, []), _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
          var _ref3;

          if (_isArray3) {
            if (_i3 >= _iterator3.length) break;
            _ref3 = _iterator3[_i3++];
          } else {
            _i3 = _iterator3.next();
            if (_i3.done) break;
            _ref3 = _i3.value;
          }

          var id = _ref3;
          cov_1n0vzmhyuy.s[95]++;

          $CRUDService.delet(PATH, { action: 'supp', id: id });
        }
        cov_1n0vzmhyuy.s[96]++;
        for (var _iterator4 = $scope.listMilestone, _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : _iterator4[Symbol.iterator]();;) {
          var _ref4;

          if (_isArray4) {
            if (_i4 >= _iterator4.length) break;
            _ref4 = _iterator4[_i4++];
          } else {
            _i4 = _iterator4.next();
            if (_i4.done) break;
            _ref4 = _i4.value;
          }

          var milestone = _ref4;
          cov_1n0vzmhyuy.s[97]++;

          milestone.ID_PROJET = data;
          cov_1n0vzmhyuy.s[98]++;
          milestone.REALIZE = milestone.REALIZE ? (cov_1n0vzmhyuy.b[31][0]++, 1) : (cov_1n0vzmhyuy.b[31][1]++, 0);
          cov_1n0vzmhyuy.s[99]++;
          $CRUDService.save(PATH, { action: 'miseAJour', valeur: $filter('json')(milestone) });
        }
        cov_1n0vzmhyuy.s[100]++;
        for (var _iterator5 = $scope.listFiscalYears, _isArray5 = Array.isArray(_iterator5), _i5 = 0, _iterator5 = _isArray5 ? _iterator5 : _iterator5[Symbol.iterator]();;) {
          var _ref5;

          if (_isArray5) {
            if (_i5 >= _iterator5.length) break;
            _ref5 = _iterator5[_i5++];
          } else {
            _i5 = _iterator5.next();
            if (_i5.done) break;
            _ref5 = _i5.value;
          }

          var per = _ref5;
          cov_1n0vzmhyuy.s[101]++;

          $CRUDService.save('Periode', { action: 'save_periode_project', id: data, valeur: $filter('json')({
              ANNEE_PERIOD: per.year,
              DECOUPAGE_PERIOD: per.period.id,
              id: per.id
            }) }, function (_data) {
            cov_1n0vzmhyuy.f[11]++;
            cov_1n0vzmhyuy.s[102]++;

            if (_data == -1) {
              cov_1n0vzmhyuy.b[32][0]++;
              cov_1n0vzmhyuy.s[103]++;

              return;
            } else {
              cov_1n0vzmhyuy.b[32][1]++;
            }
          });
        }
      } else {
        cov_1n0vzmhyuy.b[29][1]++;
      }
      cov_1n0vzmhyuy.s[104]++;
      $scope.cancel();
      cov_1n0vzmhyuy.s[105]++;
      $scope.listProjects = $filter('orderBy')($scope.listProjects, 'CODE_PRJ');
      cov_1n0vzmhyuy.s[106]++;
      $scope.filter.processFilter();
    });
  };

  cov_1n0vzmhyuy.s[107]++;
  $scope.nextPage = function () {
    cov_1n0vzmhyuy.f[12]++;
  };

  cov_1n0vzmhyuy.s[108]++;
  $scope.select = function (projet) {
    cov_1n0vzmhyuy.f[13]++;

    var selectedProjet = (cov_1n0vzmhyuy.s[109]++, angular.copy(projet));
    cov_1n0vzmhyuy.s[110]++;


    $rootScope.setAtHome(false);
    cov_1n0vzmhyuy.s[111]++;
    $otherHttpService.post($scope.PATH, { action: 'setActive', id: projet.id }, function (data) {
      cov_1n0vzmhyuy.f[14]++;
      cov_1n0vzmhyuy.s[112]++;

      $rootScope.setProject({
        project: selectedProjet,
        droit: data.droits,
        connected: data.connect,
        link: data.a,
        admin: data.res,
        isAdmin: data.isAdmin,
        canAccessAdminPanel: data.canAccessAdminPanel,
        profils: data.profils,
        lastLogLevel: data.lL,
        portfolio: data.portfolio
      });
      cov_1n0vzmhyuy.s[113]++;
      $deltaclearData.clearData();
      cov_1n0vzmhyuy.s[114]++;
      $deltaGeoData.__initialise();
      cov_1n0vzmhyuy.s[115]++;
      $location.path('/app/dashboard').replace();
    });
  };

  cov_1n0vzmhyuy.s[116]++;
  $scope.edit = function (item) {
    cov_1n0vzmhyuy.f[15]++;
    cov_1n0vzmhyuy.s[117]++;


    $scope.location = {
      open: false,
      selected: {},
      select: function select(item) {
        cov_1n0vzmhyuy.s[118]++;

        if (this.selected[item.CODE_LC]) {
          cov_1n0vzmhyuy.b[33][0]++;
          cov_1n0vzmhyuy.s[119]++;

          delete this.selected[item.CODE_LC];
          cov_1n0vzmhyuy.s[120]++;
          return;
        } else {
          cov_1n0vzmhyuy.b[33][1]++;
        }
        cov_1n0vzmhyuy.s[121]++;
        this.selected[item.CODE_LC] = item.CODE_LC + ': ' + item.DESCRIPTION_L;
      },
      transform: function transform() {
        var selectedZone = (cov_1n0vzmhyuy.s[122]++, []);
        var keys = (cov_1n0vzmhyuy.s[123]++, []);
        cov_1n0vzmhyuy.s[124]++;
        this.selected = {};
        cov_1n0vzmhyuy.s[125]++;
        for (var _iterator6 = Object.keys($scope.selectedItem.LOCATION_FIELD), _isArray6 = Array.isArray(_iterator6), _i6 = 0, _iterator6 = _isArray6 ? _iterator6 : _iterator6[Symbol.iterator]();;) {
          var _ref6;

          if (_isArray6) {
            if (_i6 >= _iterator6.length) break;
            _ref6 = _iterator6[_i6++];
          } else {
            _i6 = _iterator6.next();
            if (_i6.done) break;
            _ref6 = _i6.value;
          }

          var key = _ref6;
          cov_1n0vzmhyuy.s[126]++;

          this.selected[key] = $scope.selectedItem.LOCATION_FIELD[key];
          cov_1n0vzmhyuy.s[127]++;
          selectedZone.push($scope.selectedItem.LOCATION_FIELD[key]);
          cov_1n0vzmhyuy.s[128]++;
          keys.push('' + key);
        }
        cov_1n0vzmhyuy.s[129]++;
        $scope.selectedItem.ZONE_ = selectedZone.join(' , ');
        cov_1n0vzmhyuy.s[130]++;
        $scope.selectedItem.LOCATION_FIELD = keys.join(';');
      },
      validate: function validate() {
        var selectedZone = (cov_1n0vzmhyuy.s[131]++, []);
        var keys = (cov_1n0vzmhyuy.s[132]++, []);
        cov_1n0vzmhyuy.s[133]++;
        for (var _iterator7 = Object.keys(this.selected), _isArray7 = Array.isArray(_iterator7), _i7 = 0, _iterator7 = _isArray7 ? _iterator7 : _iterator7[Symbol.iterator]();;) {
          var _ref7;

          if (_isArray7) {
            if (_i7 >= _iterator7.length) break;
            _ref7 = _iterator7[_i7++];
          } else {
            _i7 = _iterator7.next();
            if (_i7.done) break;
            _ref7 = _i7.value;
          }

          var key = _ref7;
          cov_1n0vzmhyuy.s[134]++;

          selectedZone.push(this.selected[key]);
          cov_1n0vzmhyuy.s[135]++;
          keys.push('' + key);
        }
        cov_1n0vzmhyuy.s[136]++;
        $scope.selectedItem.ZONE_ = selectedZone.join(' , ');
        cov_1n0vzmhyuy.s[137]++;
        $scope.selectedItem.LOCATION_FIELD = keys.join(';');
        cov_1n0vzmhyuy.s[138]++;
        this.open = false;
      }
    };

    cov_1n0vzmhyuy.s[139]++;
    $scope.autoCompleteGroupOptions = null;
    cov_1n0vzmhyuy.s[140]++;
    $CRUDService.getAll($scope.PATH, { get: 'devises', id_projet: $scope.selectedItem.ID_PARENT }, function (_data2) {
      cov_1n0vzmhyuy.f[16]++;
      cov_1n0vzmhyuy.s[141]++;

      $scope.autoCompleteGroupOptions = {
        minimumChars: 0,
        containerCssClass: 'white-bg',
        selectedCssClass: 'selected-item-auto-complete',
        noMatchTemplateEnabled: false,
        activateOnFocus: true,
        data: function data(searchText) {
          cov_1n0vzmhyuy.s[142]++;

          return _data2;
        }
      };
    });

    cov_1n0vzmhyuy.s[143]++;

    $scope.LAST_START_MONTH = item.START_MONTH;
    cov_1n0vzmhyuy.s[144]++;
    $scope.addingSource = [];
    cov_1n0vzmhyuy.s[145]++;
    $scope.edit.tab = 1;
    cov_1n0vzmhyuy.s[146]++;
    $scope.edit.tabPeriod = 1;
    cov_1n0vzmhyuy.s[147]++;
    $scope.error_code = false;
    cov_1n0vzmhyuy.s[148]++;
    $scope.isadd = true;
    cov_1n0vzmhyuy.s[149]++;
    $scope.selectedItem = angular.copy(item);
    cov_1n0vzmhyuy.s[150]++;
    $scope.selectedItem.PERIODIC_FOLLOW = $filter('filter')($scope.listPeriodicity, { id: (cov_1n0vzmhyuy.b[34][0]++, item.PERIODIC_FOLLOW) || (cov_1n0vzmhyuy.b[34][1]++, '1') }, true)[0];
    cov_1n0vzmhyuy.s[151]++;
    $scope.selectedItem.STATUS = $filter('filter')($scope.statutsList, { id: (cov_1n0vzmhyuy.b[35][0]++, parseInt(item.STATUS, 10)) || (cov_1n0vzmhyuy.b[35][1]++, 1) })[0];
    cov_1n0vzmhyuy.s[152]++;

    $scope.selectedItem.ID_LOG_FRAME = 0;
    cov_1n0vzmhyuy.s[153]++;
    if ((cov_1n0vzmhyuy.b[37][0]++, item.ID_LOG_FRAME) && (cov_1n0vzmhyuy.b[37][1]++, item.ID_LOG_FRAME != '') && (cov_1n0vzmhyuy.b[37][2]++, typeof item.ID_LOG_FRAME != 'undefined')) {
      cov_1n0vzmhyuy.b[36][0]++;
      cov_1n0vzmhyuy.s[154]++;

      $scope.selectedItem.ID_LOG_FRAME = parseInt(item.ID_LOG_FRAME);
    } else {
      cov_1n0vzmhyuy.b[36][1]++;
    }
    cov_1n0vzmhyuy.s[155]++;
    $scope.langselect = $LOGINService.getLang();
    cov_1n0vzmhyuy.s[156]++;

    $scope.selectedItem.START_MONTH = $filter('filter')($scope.listMonths, { index: parseInt((cov_1n0vzmhyuy.b[38][0]++, item.START_MONTH) || (cov_1n0vzmhyuy.b[38][1]++, 1), 10) }, true)[0];

    cov_1n0vzmhyuy.s[157]++;
    $scope.selectedItem.IDACTEURS = $scope.actorsList.find(function (actor) {
      cov_1n0vzmhyuy.f[17]++;
      cov_1n0vzmhyuy.s[158]++;

      return actor.id == $scope.selectedItem.IDACTEURS;
    });

    cov_1n0vzmhyuy.s[159]++;
    $scope.selectedItem.TYPE_PROJECT = $scope.typeList.find(function (currentType) {
      cov_1n0vzmhyuy.f[18]++;
      cov_1n0vzmhyuy.s[160]++;

      return currentType.id == $scope.selectedItem.TYPE_PROJECT;
    });

    cov_1n0vzmhyuy.s[161]++;
    $scope.selectedItem.GLOBAL_PLAN = item.GLOBAL_PLAN == 1;
    cov_1n0vzmhyuy.s[162]++;
    $scope.selectedItem.CUSTOM_FIELD = item.CUSTOM_FIELD == 1;
    cov_1n0vzmhyuy.s[163]++;
    $scope.selectedItem.ACTIVITY_WEIGHT = item.ACTIVITY_WEIGHT == 1;
    cov_1n0vzmhyuy.s[164]++;
    $scope.selectedItem.DISPLAY_DATA = item.DISPLAY_DATA == 1;
    cov_1n0vzmhyuy.s[165]++;
    $scope.selectedItem.LINK_PG = item.LINK_PG == 1;
    cov_1n0vzmhyuy.s[166]++;

    $scope.selectedItem.PAYS_PROJET = { id: 0 };
    cov_1n0vzmhyuy.s[167]++;
    $scope.selectedItem.LINK = {
      U: $scope.selectedItem.LINK.U != 0,
      SF: $scope.selectedItem.LINK.SF != 0,
      PG: $scope.selectedItem.LINK.PG != 0,
      PL: $scope.selectedItem.LINK.PL != 0,
      F: $scope.selectedItem.LINK.F != 0,
      TA: $scope.selectedItem.LINK.TA != 0,
      TI: $scope.selectedItem.LINK.TI != 0,
      TR: $scope.selectedItem.LINK.TR != 0,
      FR: $scope.selectedItem.LINK.FR != 0
    };
    cov_1n0vzmhyuy.s[168]++;
    $scope.selectedItem.IDS_AGENCY = [];
    cov_1n0vzmhyuy.s[169]++;
    $scope.selectedItem.AMOUNT = parseFloat((cov_1n0vzmhyuy.b[39][0]++, item.AMOUNT) || (cov_1n0vzmhyuy.b[39][1]++, '0'));
    cov_1n0vzmhyuy.s[170]++;
    $scope.selectedItem.EXCHANGE = parseFloat((cov_1n0vzmhyuy.b[40][0]++, item.EXCHANGE) || (cov_1n0vzmhyuy.b[40][1]++, '1'));
    cov_1n0vzmhyuy.s[171]++;
    $scope.selectedItem.IDS_SECTOR = [];

    cov_1n0vzmhyuy.s[172]++;


    for (var _iterator8 = $scope.agencies, _isArray8 = Array.isArray(_iterator8), _i8 = 0, _iterator8 = _isArray8 ? _iterator8 : _iterator8[Symbol.iterator]();;) {
      var _ref8;

      if (_isArray8) {
        if (_i8 >= _iterator8.length) break;
        _ref8 = _iterator8[_i8++];
      } else {
        _i8 = _iterator8.next();
        if (_i8.done) break;
        _ref8 = _i8.value;
      }

      var agency = _ref8;
      cov_1n0vzmhyuy.s[173]++;

      if (item.IDS_AGENCY.indexOf(agency.id) >= 0) {
        cov_1n0vzmhyuy.b[41][0]++;
        cov_1n0vzmhyuy.s[174]++;

        $scope.selectedItem.IDS_AGENCY.push(agency);
      } else {
        cov_1n0vzmhyuy.b[41][1]++;
      }
    }
    cov_1n0vzmhyuy.s[175]++;
    for (var _iterator9 = $scope.sectors, _isArray9 = Array.isArray(_iterator9), _i9 = 0, _iterator9 = _isArray9 ? _iterator9 : _iterator9[Symbol.iterator]();;) {
      var _ref9;

      if (_isArray9) {
        if (_i9 >= _iterator9.length) break;
        _ref9 = _iterator9[_i9++];
      } else {
        _i9 = _iterator9.next();
        if (_i9.done) break;
        _ref9 = _i9.value;
      }

      var sector = _ref9;
      cov_1n0vzmhyuy.s[176]++;

      if (item.IDS_SECTOR.indexOf(sector.id) >= 0) {
        cov_1n0vzmhyuy.b[42][0]++;
        cov_1n0vzmhyuy.s[177]++;

        $scope.selectedItem.IDS_SECTOR.push(sector);
      } else {
        cov_1n0vzmhyuy.b[42][1]++;
      }
    }
    cov_1n0vzmhyuy.s[178]++;
    $scope.defaulSelect = 'Elvis';
    cov_1n0vzmhyuy.s[179]++;
    if (item.id) {
      cov_1n0vzmhyuy.b[43][0]++;
      cov_1n0vzmhyuy.s[180]++;

      $CRUDService.getAll('NiveauCl', { get: 'count', id: item.id }, function (data) {
        cov_1n0vzmhyuy.f[19]++;
        cov_1n0vzmhyuy.s[181]++;

        $scope.blockDelete = parseInt(data, 10) > 0;
      });
    } else {
      cov_1n0vzmhyuy.b[43][1]++;
      cov_1n0vzmhyuy.s[182]++;

      $scope.blockDelete = false;
    }
    cov_1n0vzmhyuy.s[183]++;
    $scope.listPeriodCutting = {};
    cov_1n0vzmhyuy.s[184]++;
    $CRUDService.getAll('Periode', { get: 'all_projet', id: $scope.selectedItem.id }, function (data) {
      cov_1n0vzmhyuy.f[20]++;
      cov_1n0vzmhyuy.s[185]++;

      for (var _iterator10 = data, _isArray10 = Array.isArray(_iterator10), _i10 = 0, _iterator10 = _isArray10 ? _iterator10 : _iterator10[Symbol.iterator]();;) {
        var _ref10;

        if (_isArray10) {
          if (_i10 >= _iterator10.length) break;
          _ref10 = _iterator10[_i10++];
        } else {
          _i10 = _iterator10.next();
          if (_i10.done) break;
          _ref10 = _i10.value;
        }

        var it = _ref10;
        cov_1n0vzmhyuy.s[186]++;

        $scope.listPeriodCutting[it.ANNEE_PERIOD] = {
          period: it.DECOUPAGE_PERIOD,
          id: it.id
        };
      }
      cov_1n0vzmhyuy.s[187]++;

      $scope.changeMonth();
    });
    cov_1n0vzmhyuy.s[188]++;
    $scope.locks = {
      plan_global: false,
      periods: [],
      start_month: 0
    };
    cov_1n0vzmhyuy.s[189]++;
    $CRUDService.getAll($scope.PATH, { get: 'can_update', id: $scope.selectedItem.id }, function (data) {
      cov_1n0vzmhyuy.f[21]++;
      cov_1n0vzmhyuy.s[190]++;

      $scope.locks = data;
      cov_1n0vzmhyuy.s[191]++;
      $scope.locks.start_month = parseInt($scope.locks.start_month, 10);
    });
    var d = (cov_1n0vzmhyuy.s[192]++, $filter('filter')($scope.agencies, { id: $scope.selectedItem.ID_AGENCY }, true));
    cov_1n0vzmhyuy.s[193]++;
    if (d.length > 0) {
      cov_1n0vzmhyuy.b[44][0]++;
      cov_1n0vzmhyuy.s[194]++;

      $scope.selectedItem.ID_AGENCY = d[0];
    } else {
      cov_1n0vzmhyuy.b[44][1]++;
      cov_1n0vzmhyuy.s[195]++;

      $scope.selectedItem.ID_AGENCY = $scope.agencies[$scope.agencies.length - 1];
    }
    cov_1n0vzmhyuy.s[196]++;
    $scope.isedit = $scope.selectedItem.id == 0;
    cov_1n0vzmhyuy.s[197]++;
    $scope.deletedMilestone = [];
    cov_1n0vzmhyuy.s[198]++;
    $CRUDService.getAll(PATH, { get: 'all', id: (cov_1n0vzmhyuy.b[45][0]++, item.id) || (cov_1n0vzmhyuy.b[45][1]++, 0) }, function (data) {
      cov_1n0vzmhyuy.f[22]++;
      cov_1n0vzmhyuy.s[199]++;

      for (var _iterator11 = data, _isArray11 = Array.isArray(_iterator11), _i11 = 0, _iterator11 = _isArray11 ? _iterator11 : _iterator11[Symbol.iterator]();;) {
        var _ref11;

        if (_isArray11) {
          if (_i11 >= _iterator11.length) break;
          _ref11 = _iterator11[_i11++];
        } else {
          _i11 = _iterator11.next();
          if (_i11.done) break;
          _ref11 = _i11.value;
        }

        var el = _ref11;
        cov_1n0vzmhyuy.s[200]++;

        if (el.PLANNED_DATE) {
          cov_1n0vzmhyuy.b[46][0]++;
          cov_1n0vzmhyuy.s[201]++;

          el.PLANNED_DATE = Date.newDate(el.PLANNED_DATE);
        } else {
          cov_1n0vzmhyuy.b[46][1]++;
        }
        cov_1n0vzmhyuy.s[202]++;
        if (el.ACTUAL_DATE) {
          cov_1n0vzmhyuy.b[47][0]++;
          cov_1n0vzmhyuy.s[203]++;

          el.ACTUAL_DATE = Date.newDate(el.ACTUAL_DATE);
        } else {
          cov_1n0vzmhyuy.b[47][1]++;
        }

        cov_1n0vzmhyuy.s[204]++;
        el.REALIZE = el.REALIZE == 1;
      }
      cov_1n0vzmhyuy.s[205]++;
      $scope.listMilestone = data;
    });
    cov_1n0vzmhyuy.s[206]++;
    $scope.selectedItem.GPS = [1, 1, 1];
    cov_1n0vzmhyuy.s[207]++;
    $scope.location.transform();
  };

  cov_1n0vzmhyuy.s[208]++;
  $scope.initEditMap = function () {
    cov_1n0vzmhyuy.f[23]++;
    cov_1n0vzmhyuy.s[209]++;

    if ($scope.mymapEdit) {
      cov_1n0vzmhyuy.b[48][0]++;
      cov_1n0vzmhyuy.s[210]++;

      return;
    } else {
      cov_1n0vzmhyuy.b[48][1]++;
    }
    cov_1n0vzmhyuy.s[211]++;
    try {
      cov_1n0vzmhyuy.s[212]++;

      $scope.mymapEdit = L.map('map_editing', { fullscreenControl: {
          title: {
            false: $translate.instant('COMMON.FULLSCREEN'),
            true: $translate.instant('COMMON.EXIT_FULLSCREEN')
          }
        } }).setView([16.82, 11.3], 6);
    } catch (e) {
      cov_1n0vzmhyuy.s[213]++;

      return;
    }

    cov_1n0vzmhyuy.s[214]++;
    $scope.layerGroupEdit = L.layerGroup([], {
      attribution: '© <a href=\'https://www.mapbox.com/about/maps/\'>Mapbox</a> , © <a href=\'https://www.openstreetmap.org/copyright\'>OpenStreetMap</a>  <strong><a href=\'https://www.mapbox.com/map-feedback/\' target=\'_blank\'>Improve this map</a></strong>'
    });
    cov_1n0vzmhyuy.s[215]++;
    $scope.layerGroupEdit.addTo($scope.mymapEdit);

    var mapstr__ = (cov_1n0vzmhyuy.s[216]++, 'https://api.mapbox.com/styles/v1/bksb/cjnem4vy029oz2sphj8jvnp9a/tiles/256/{z}/{x}/{y}?access_token=pk.eyJ1IjoiYmtzYiIsImEiOiJjaXQ5ZHlpM2gwMDJvMnNwaDAxZXFsbndrIn0.0W3tcj-HtlRSCJDcuxNRew');
    cov_1n0vzmhyuy.s[217]++;
    L.tileLayer(mapstr__).addTo($scope.mymapEdit);
  };

  cov_1n0vzmhyuy.s[218]++;
  $scope.loadItemProject = function (item, edit) {
    var _this2 = this;

    cov_1n0vzmhyuy.f[24]++;

    var toda = (cov_1n0vzmhyuy.s[219]++, Date.newDate());

    cov_1n0vzmhyuy.s[220]++;
    if (item.cellIndex) {
      cov_1n0vzmhyuy.b[49][0]++;
      cov_1n0vzmhyuy.s[221]++;

      if (item.cellIndex.cellIndex == 0) {
        cov_1n0vzmhyuy.b[50][0]++;
        cov_1n0vzmhyuy.s[222]++;

        $scope.toggleFlavor(item.data);
        cov_1n0vzmhyuy.s[223]++;
        $('#flavors_column_' + item.data.id).toggleClass('text-warning');
        cov_1n0vzmhyuy.s[224]++;
        $('#flavors_column_' + item.data.id).toggleClass('flavor-item');
      } else {
        cov_1n0vzmhyuy.b[50][1]++;
      }
      cov_1n0vzmhyuy.s[225]++;
      if ((cov_1n0vzmhyuy.b[52][0]++, item.cellIndex.cellIndex == 10) || (cov_1n0vzmhyuy.b[52][1]++, item.cellIndex.cellIndex == 0)) {
        cov_1n0vzmhyuy.b[51][0]++;
        cov_1n0vzmhyuy.s[226]++;

        return;
      } else {
        cov_1n0vzmhyuy.b[51][1]++;
      }
    } else {
      cov_1n0vzmhyuy.b[49][1]++;
    }
    cov_1n0vzmhyuy.s[227]++;
    this.isloading = true;
    cov_1n0vzmhyuy.s[228]++;
    $CRUDService.getAll($scope.PATH, { get: 'single', id: ((cov_1n0vzmhyuy.b[53][0]++, item.data) || (cov_1n0vzmhyuy.b[53][1]++, item)).id }, function (data) {
      cov_1n0vzmhyuy.f[25]++;
      cov_1n0vzmhyuy.s[229]++;

      if (data.length <= 0) {
        cov_1n0vzmhyuy.b[54][0]++;
        cov_1n0vzmhyuy.s[230]++;

        _this2.isloading = false;
        cov_1n0vzmhyuy.s[231]++;
        return;
      } else {
        cov_1n0vzmhyuy.b[54][1]++;
      }
      cov_1n0vzmhyuy.s[232]++;
      for (var i = 0; i < data.length; i++) {
        cov_1n0vzmhyuy.s[233]++;

        if (!data[i].DATE_DEB_PROJET) {
          cov_1n0vzmhyuy.b[55][0]++;
          cov_1n0vzmhyuy.s[234]++;

          continue;
        } else {
          cov_1n0vzmhyuy.b[55][1]++;
        }
        cov_1n0vzmhyuy.s[235]++;
        data[i].img = $deltahttp.getProjectRepository(data[i].id, currentDate);
        cov_1n0vzmhyuy.s[236]++;
        data[i].DATE_DEB_PROJET = Date.newDate(data[i].DATE_DEB_PROJET);
        cov_1n0vzmhyuy.s[237]++;
        data[i].COUT = eval(data[i].COUT);
        cov_1n0vzmhyuy.s[238]++;
        data[i].STATUT_BUDGET = parseInt(data[i].STATUT_BUDGET, 10) === 1;
        cov_1n0vzmhyuy.s[239]++;
        data[i].DATE_FIN_PROJET = Date.newDate(data[i].DATE_FIN_PROJET);
        cov_1n0vzmhyuy.s[240]++;
        data[i].DATE_MI_PRO = Date.newDate((cov_1n0vzmhyuy.b[56][0]++, data[i].DATE_MI_PRO) || (cov_1n0vzmhyuy.b[56][1]++, undefined));
        var diff = (cov_1n0vzmhyuy.s[241]++, data[i].DATE_FIN_PROJET - data[i].DATE_DEB_PROJET);
        cov_1n0vzmhyuy.s[242]++;
        data[i].progress = 0;
        cov_1n0vzmhyuy.s[243]++;
        if (diff != 0) {
          cov_1n0vzmhyuy.b[57][0]++;
          cov_1n0vzmhyuy.s[244]++;

          data[i].progress = Math.min((toda - data[i].DATE_DEB_PROJET) / diff * 100, 100);
        } else {
          cov_1n0vzmhyuy.b[57][1]++;
        }
        cov_1n0vzmhyuy.s[245]++;
        if (data[i].progress < 0) {
          cov_1n0vzmhyuy.b[58][0]++;
          cov_1n0vzmhyuy.s[246]++;

          data[i].progress = 0;
        } else {
          cov_1n0vzmhyuy.b[58][1]++;
        }
        cov_1n0vzmhyuy.s[247]++;
        data[i].PAYS_PROJET = parseInt(data[i].PAYS_PROJET, 10);
        cov_1n0vzmhyuy.s[248]++;

        data[i].progress = {
          data: [{
            value: data[i].progress,
            highlight: '#1ab394',
            label: '',
            color: '#1ab394'

          }, {
            value: 100 - data[i].progress,
            highlight: '#d7d7d7',
            label: '',
            color: '#d7d7d7'
          }]
        };
      }

      cov_1n0vzmhyuy.s[249]++;
      if (edit) {
        cov_1n0vzmhyuy.b[59][0]++;
        cov_1n0vzmhyuy.s[250]++;

        _this2.isloading = false;
        cov_1n0vzmhyuy.s[251]++;
        $scope.edit(data[0]);
      } else {
        cov_1n0vzmhyuy.b[59][1]++;
        cov_1n0vzmhyuy.s[252]++;

        $scope.select(data[0]);
      }
    });
  };

  cov_1n0vzmhyuy.s[253]++;
  $scope.customAllItems = function (type) {
    var withColor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (cov_1n0vzmhyuy.b[60][0]++, false);
    cov_1n0vzmhyuy.f[26]++;
    cov_1n0vzmhyuy.s[254]++;

    $rootScope.updateCustomFields({ type: type, withColor: withColor, title: $translate.instant(type == 2 ? (cov_1n0vzmhyuy.b[61][0]++, 'PROJECT.TYPE') : (cov_1n0vzmhyuy.b[61][1]++, 'PROJECT.STATUS')) });
  };

  cov_1n0vzmhyuy.s[255]++;
  $scope.getGlobalActor = function () {
    cov_1n0vzmhyuy.f[27]++;
    cov_1n0vzmhyuy.s[256]++;

    $scope.actorsList = [{ id: '0', name: $translate.instant('PROJECT.ACTOR_NONE') }];

    cov_1n0vzmhyuy.s[257]++;
    $scope.loadingActors = true;

    cov_1n0vzmhyuy.s[258]++;
    $CRUDService.getAll('Acteurs', { get: 'allglobal', id_projet: $scope.selectedItem.ID_PARENT }, function (data) {
      cov_1n0vzmhyuy.f[28]++;
      cov_1n0vzmhyuy.s[259]++;

      $scope.actorsList = $scope.actorsList.concat(data);

      cov_1n0vzmhyuy.s[260]++;
      if ($scope.selectedItem) {
        cov_1n0vzmhyuy.b[62][0]++;
        cov_1n0vzmhyuy.s[261]++;

        if ($scope.selectedItem.IDACTEURS) {
          cov_1n0vzmhyuy.b[63][0]++;
          cov_1n0vzmhyuy.s[262]++;

          $scope.selectedItem.IDACTEURS = $scope.actorsList.find(function (actor) {
            cov_1n0vzmhyuy.f[29]++;
            cov_1n0vzmhyuy.s[263]++;

            return actor.id == $scope.selectedItem.IDACTEURS.id;
          });
        } else {
          cov_1n0vzmhyuy.b[63][1]++;
        }

        cov_1n0vzmhyuy.s[264]++;
        if (!$scope.selectedItem.IDACTEURS) {
          cov_1n0vzmhyuy.b[64][0]++;
          cov_1n0vzmhyuy.s[265]++;

          $scope.selectedItem.IDACTEURS = $scope.actorsList[0];
        } else {
          cov_1n0vzmhyuy.b[64][1]++;
        }
      } else {
        cov_1n0vzmhyuy.b[62][1]++;
      }

      cov_1n0vzmhyuy.s[266]++;
      $scope.loadingActors = false;
    });
  };

  cov_1n0vzmhyuy.s[267]++;
  $scope.cancel = function () {
    cov_1n0vzmhyuy.f[30]++;
    cov_1n0vzmhyuy.s[268]++;

    $scope.loadItemProject($scope.selectedProjet, false);
  };

  cov_1n0vzmhyuy.s[269]++;
  $scope.addAgenceNew = function () {
    cov_1n0vzmhyuy.f[31]++;
    cov_1n0vzmhyuy.s[270]++;

    $scope.error_code = false;
    cov_1n0vzmhyuy.s[271]++;
    $scope.selectedItemAgencies = {
      NAME_AG: '',
      SHORT_NAME_AG: '',
      ADDRESS_AG: '',
      CITY_AG: '',
      COUNTRY_AG: '1',
      id: 0,
      TEL: '',
      FAX: '',
      EMAIL: '',
      SITE_WEB: ''
    };
    cov_1n0vzmhyuy.s[272]++;
    $uibModal.open({
      templateUrl: 'app/views/agencies/modal.html',
      controller: AgenciesCtrl_Project_edit,
      scope: $scope,
      size: 'sm_',
      backdrop: 'static',
      windowClass: 'animated fadeInRight left-modal'
    });
  };
  cov_1n0vzmhyuy.s[273]++;
  $scope.updateAgencies = function (item, deleteItem) {
    cov_1n0vzmhyuy.f[32]++;
    cov_1n0vzmhyuy.s[274]++;

    if (deleteItem) {
      cov_1n0vzmhyuy.b[65][0]++;
      cov_1n0vzmhyuy.s[275]++;

      $scope.agencies = $scope.agencies.filter(function (sector) {
        cov_1n0vzmhyuy.f[33]++;
        cov_1n0vzmhyuy.s[276]++;

        return sector.id != item.id;
      });
      cov_1n0vzmhyuy.s[277]++;
      return;
    } else {
      cov_1n0vzmhyuy.b[65][1]++;
    }
    cov_1n0vzmhyuy.s[278]++;
    for (var _iterator12 = $scope.agencies, _isArray12 = Array.isArray(_iterator12), _i12 = 0, _iterator12 = _isArray12 ? _iterator12 : _iterator12[Symbol.iterator]();;) {
      var _ref12;

      if (_isArray12) {
        if (_i12 >= _iterator12.length) break;
        _ref12 = _iterator12[_i12++];
      } else {
        _i12 = _iterator12.next();
        if (_i12.done) break;
        _ref12 = _i12.value;
      }

      var agency = _ref12;
      cov_1n0vzmhyuy.s[279]++;

      if (agency.id == item.id) {
        cov_1n0vzmhyuy.b[66][0]++;
        cov_1n0vzmhyuy.s[280]++;

        agency.NAME_AG = item.NAME_AG;
        cov_1n0vzmhyuy.s[281]++;
        return;
      } else {
        cov_1n0vzmhyuy.b[66][1]++;
      }
    }
    cov_1n0vzmhyuy.s[282]++;
    $scope.agencies.push(item);
  };

  cov_1n0vzmhyuy.s[283]++;
  $scope.openSector = function () {
    cov_1n0vzmhyuy.f[34]++;
    cov_1n0vzmhyuy.s[284]++;

    $uibModal.open({
      templateUrl: 'app/views/project/sectors.html',
      controller: SectorsCtrl_Project_edit,
      scope: $scope,
      size: 'sm_',
      backdrop: 'static',
      windowClass: 'animated fadeInRight left-modal'
    });
  };
  cov_1n0vzmhyuy.s[285]++;
  $scope.updateSector = function (item, deleteItem) {
    cov_1n0vzmhyuy.f[35]++;
    cov_1n0vzmhyuy.s[286]++;

    if (deleteItem) {
      cov_1n0vzmhyuy.b[67][0]++;
      cov_1n0vzmhyuy.s[287]++;

      $scope.sectors = $scope.sectors.filter(function (sector) {
        cov_1n0vzmhyuy.f[36]++;
        cov_1n0vzmhyuy.s[288]++;

        return sector.id != item.id;
      });
      cov_1n0vzmhyuy.s[289]++;
      return;
    } else {
      cov_1n0vzmhyuy.b[67][1]++;
    }
    cov_1n0vzmhyuy.s[290]++;
    for (var _iterator13 = $scope.sectors, _isArray13 = Array.isArray(_iterator13), _i13 = 0, _iterator13 = _isArray13 ? _iterator13 : _iterator13[Symbol.iterator]();;) {
      var _ref13;

      if (_isArray13) {
        if (_i13 >= _iterator13.length) break;
        _ref13 = _iterator13[_i13++];
      } else {
        _i13 = _iterator13.next();
        if (_i13.done) break;
        _ref13 = _i13.value;
      }

      var sector = _ref13;
      cov_1n0vzmhyuy.s[291]++;

      if (sector.id == item.id) {
        cov_1n0vzmhyuy.b[68][0]++;
        cov_1n0vzmhyuy.s[292]++;

        sector.NAME = item.NAME;
        cov_1n0vzmhyuy.s[293]++;
        sector.COLOR = item.COLOR;
        cov_1n0vzmhyuy.s[294]++;
        return;
      } else {
        cov_1n0vzmhyuy.b[68][1]++;
      }
    }
    cov_1n0vzmhyuy.s[295]++;
    $scope.sectors.push(item);
  };

  cov_1n0vzmhyuy.s[296]++;
  $scope.saveSource = function (item) {
    cov_1n0vzmhyuy.f[37]++;
    cov_1n0vzmhyuy.s[297]++;

    $scope.addingSource.push(item);


    var data = (cov_1n0vzmhyuy.s[298]++, ((cov_1n0vzmhyuy.b[69][0]++, $scope.selectedItem.FINAN) || (cov_1n0vzmhyuy.b[69][1]++, '')).trim().split(',').map(function (value) {
      cov_1n0vzmhyuy.f[38]++;
      cov_1n0vzmhyuy.s[299]++;
      return value.trim();
    }));

    cov_1n0vzmhyuy.s[300]++;
    data.push(item.LIBELLE_FIN);
    cov_1n0vzmhyuy.s[301]++;
    $scope.selectedItem.FINAN = data.join(', ');
  };

  cov_1n0vzmhyuy.s[302]++;
  $scope.getAllItems = function () {
    cov_1n0vzmhyuy.f[39]++;
    cov_1n0vzmhyuy.s[303]++;


    $CRUDService.getAll(PATH_CUSTOM_FIELDS, { type: 1, get: 'single' }, function (data) {
      cov_1n0vzmhyuy.f[40]++;
      cov_1n0vzmhyuy.s[304]++;

      if (!angular.isObject(data)) {
        cov_1n0vzmhyuy.b[70][0]++;
        cov_1n0vzmhyuy.s[305]++;

        $scope.statutsList = [{ id: 1, name: $translate.instant('PROJECT.STATUTS.NOT_STARTED'), class: 'label-success' }, { id: 2, name: $translate.instant('PROJECT.STATUTS.ACTIVE'), class: 'label-primary' }, { id: 3, name: $translate.instant('PROJECT.STATUTS.SUSPENDED'), class: 'label-danger' }, { id: 4, name: $translate.instant('PROJECT.STATUTS.COMPLETED'), class: 'label-default' }, { id: 5, name: $translate.instant('PROJECT.STATUTS.ARCHIVED'), class: 'label-default' }];
      } else {
        cov_1n0vzmhyuy.b[70][1]++;
        cov_1n0vzmhyuy.s[306]++;

        $scope.statutsList = data.VALUES_FIELD;
      }
    });

    cov_1n0vzmhyuy.s[307]++;
    $CRUDService.getAll(PATH_CUSTOM_FIELDS, { type: 2, get: 'single' }, function (data) {
      cov_1n0vzmhyuy.f[41]++;
      cov_1n0vzmhyuy.s[308]++;

      if (!angular.isObject(data)) {
        cov_1n0vzmhyuy.b[71][0]++;
        cov_1n0vzmhyuy.s[309]++;

        $scope.typeList = [{ id: 1, name: $translate.instant('PROJECT.TYPES.PROJECT') }, { id: 2, name: $translate.instant('PROJECT.TYPES.PROGRAM') }, { id: 3, name: $translate.instant('PROJECT.TYPES.OTHER') }];
      } else {
        cov_1n0vzmhyuy.b[71][1]++;
        cov_1n0vzmhyuy.s[310]++;

        $scope.typeList = data.VALUES_FIELD;
      }
    });

    cov_1n0vzmhyuy.s[311]++;
    $CRUDService.getAll('AgenciesProject', { get: 'all' }, function (data) {
      cov_1n0vzmhyuy.f[42]++;
      cov_1n0vzmhyuy.s[312]++;

      $scope.agencies = data;
      cov_1n0vzmhyuy.s[313]++;
      $scope.agencies.push({ id: 0 });
      cov_1n0vzmhyuy.s[314]++;
      $scope.filter.getAllFinancialSource();
    });

    cov_1n0vzmhyuy.s[315]++;
    $CRUDService.getAll('Sectors', { get: 'all' }, function (data) {
      cov_1n0vzmhyuy.f[43]++;
      cov_1n0vzmhyuy.s[316]++;

      $scope.sectors = data;
    });
  };

  cov_1n0vzmhyuy.s[317]++;

  $scope.getAllItems();
  cov_1n0vzmhyuy.s[318]++;
  $scope.getGlobalActor();

  cov_1n0vzmhyuy.s[319]++;
  $scope.loadItemProject($scope.selectedProjet, true);
});

function AgenciesCtrl_Project_edit($scope, $uibModalInstance, $filter, $CRUDService, SweetAlert, $translate) {
  cov_1n0vzmhyuy.f[44]++;
  cov_1n0vzmhyuy.s[320]++;

  $scope.countries = $scope.contries;
  cov_1n0vzmhyuy.s[321]++;
  $scope.selectedItemAgencies.COUNTRY_AG = $scope.countries.filter(function (country) {
    cov_1n0vzmhyuy.f[45]++;
    cov_1n0vzmhyuy.s[322]++;

    return country.id == $scope.selectedItemAgencies.COUNTRY_AG;
  })[0];

  cov_1n0vzmhyuy.s[323]++;
  $scope.error_code = false;
  var PATH = (cov_1n0vzmhyuy.s[324]++, 'AgenciesProject');

  cov_1n0vzmhyuy.s[325]++;
  $scope.addAgency = function () {
    cov_1n0vzmhyuy.f[46]++;
    cov_1n0vzmhyuy.s[326]++;

    $scope.editAgency({
      NAME_AG: '',
      SHORT_NAME_AG: '',
      ADDRESS_AG: '',
      CITY_AG: '',
      COUNTRY_AG: '1',
      id: 0,
      TEL: '',
      FAX: '',
      EMAIL: '',
      SITE_WEB: ''
    });
  };

  cov_1n0vzmhyuy.s[327]++;
  $scope.editAgency = function (item) {
    cov_1n0vzmhyuy.f[47]++;

    var country = (cov_1n0vzmhyuy.s[328]++, $scope.countries.find(function (country) {
      cov_1n0vzmhyuy.f[48]++;
      cov_1n0vzmhyuy.s[329]++;

      return item.COUNTRY_AG == country.id;
    }));

    cov_1n0vzmhyuy.s[330]++;
    if (!country) {
      cov_1n0vzmhyuy.b[72][0]++;
      cov_1n0vzmhyuy.s[331]++;

      country = $scope.countries[0];
    } else {
      cov_1n0vzmhyuy.b[72][1]++;
    }

    cov_1n0vzmhyuy.s[332]++;
    $scope.selectedAgency = Object.assign(angular.copy(item), { COUNTRY_AG: country });
  };

  cov_1n0vzmhyuy.s[333]++;
  $scope.setValidData = function () {
    cov_1n0vzmhyuy.f[49]++;

    var validateItem = (cov_1n0vzmhyuy.s[334]++, angular.copy($scope.selectedAgency));
    cov_1n0vzmhyuy.s[335]++;
    $scope.error_code = {};
    var items = (cov_1n0vzmhyuy.s[336]++, $filter('filter')($scope.agencies, { NAME_AG: validateItem.NAME_AG }, true));
    cov_1n0vzmhyuy.s[337]++;
    for (var _iterator14 = items, _isArray14 = Array.isArray(_iterator14), _i14 = 0, _iterator14 = _isArray14 ? _iterator14 : _iterator14[Symbol.iterator]();;) {
      var _ref14;

      if (_isArray14) {
        if (_i14 >= _iterator14.length) break;
        _ref14 = _iterator14[_i14++];
      } else {
        _i14 = _iterator14.next();
        if (_i14.done) break;
        _ref14 = _i14.value;
      }

      var item = _ref14;
      cov_1n0vzmhyuy.s[338]++;

      if ((cov_1n0vzmhyuy.b[74][0]++, item) && (cov_1n0vzmhyuy.b[74][1]++, item.id != validateItem.id)) {
        cov_1n0vzmhyuy.b[73][0]++;
        cov_1n0vzmhyuy.s[339]++;

        $scope.error_code.name = true;
        cov_1n0vzmhyuy.s[340]++;
        return;
      } else {
        cov_1n0vzmhyuy.b[73][1]++;
      }
    }
    cov_1n0vzmhyuy.s[341]++;
    validateItem.COUNTRY_AG = validateItem.COUNTRY_AG.id;
    cov_1n0vzmhyuy.s[342]++;
    $CRUDService.save(PATH, { action: 'MiseAJour', valeur: $filter('json')(validateItem) }, function (data) {
      cov_1n0vzmhyuy.f[50]++;
      cov_1n0vzmhyuy.s[343]++;

      validateItem.id = String(parseInt(data, 10));
      cov_1n0vzmhyuy.s[344]++;
      $scope.updateAgencies(validateItem);
      cov_1n0vzmhyuy.s[345]++;
      $scope.selectedAgency = null;
    });
  };

  cov_1n0vzmhyuy.s[346]++;
  $scope.cancelAgency = function () {
    cov_1n0vzmhyuy.f[51]++;
    cov_1n0vzmhyuy.s[347]++;

    $scope.selectedAgency = null;
  };

  cov_1n0vzmhyuy.s[348]++;
  $scope.deleteAgency = function (item) {
    cov_1n0vzmhyuy.f[52]++;
    cov_1n0vzmhyuy.s[349]++;

    SweetAlert.swal({
      title: $translate.instant('COMMON.CONFIRM'),

      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#c8c8c8',

      confirmButtonText: $translate.instant('COMMON.NO'),
      cancelButtonText: $translate.instant('COMMON.YES'),
      closeOnConfirm: true,
      closeOnCancel: true
    }, function (isconfirm) {
      cov_1n0vzmhyuy.f[53]++;
      cov_1n0vzmhyuy.s[350]++;

      if (isconfirm) {
        cov_1n0vzmhyuy.b[75][0]++;
        cov_1n0vzmhyuy.s[351]++;

        return;
      } else {
        cov_1n0vzmhyuy.b[75][1]++;
      }
      cov_1n0vzmhyuy.s[352]++;
      $scope.isloading = true;
      var validateItem = (cov_1n0vzmhyuy.s[353]++, {
        id: item.id
      });
      cov_1n0vzmhyuy.s[354]++;
      $CRUDService.delet(PATH, { action: 'supp', id: validateItem.id }, function (data) {
        cov_1n0vzmhyuy.f[54]++;
        cov_1n0vzmhyuy.s[355]++;

        if (data < 0) {
          cov_1n0vzmhyuy.b[76][0]++;
          cov_1n0vzmhyuy.s[356]++;

          SweetAlert.swal({
            title: $translate.instant('COMMON.ERROR_DELETE'),
            text: $translate.instant('PROJECT.ERROR.DELETE')
          });
          cov_1n0vzmhyuy.s[357]++;
          $scope.isloading = false;
          cov_1n0vzmhyuy.s[358]++;
          return;
        } else {
          cov_1n0vzmhyuy.b[76][1]++;
        }
        cov_1n0vzmhyuy.s[359]++;
        $scope.updateAgencies(validateItem, true);
      });
    });
  };

  cov_1n0vzmhyuy.s[360]++;
  $scope.closeModal = function () {
    cov_1n0vzmhyuy.f[55]++;
    cov_1n0vzmhyuy.s[361]++;

    $uibModalInstance.dismiss('cancel');
  };
}

function SectorsCtrl_Project_edit($scope, $uibModalInstance, $filter, $CRUDService, SweetAlert, $translate) {
  cov_1n0vzmhyuy.f[56]++;
  cov_1n0vzmhyuy.s[362]++;

  $scope.addSector = function () {
    cov_1n0vzmhyuy.f[57]++;
    cov_1n0vzmhyuy.s[363]++;

    $scope.editSector({
      id: 0,
      NAME: ''
    });
  };

  cov_1n0vzmhyuy.s[364]++;
  $scope.editSector = function (item) {
    cov_1n0vzmhyuy.f[58]++;
    cov_1n0vzmhyuy.s[365]++;

    $scope.error_code = {};
    cov_1n0vzmhyuy.s[366]++;
    $scope.selectedSector = angular.copy(item);
  };

  cov_1n0vzmhyuy.s[367]++;
  $scope.cancelSector = function () {
    cov_1n0vzmhyuy.f[59]++;
    cov_1n0vzmhyuy.s[368]++;

    $scope.selectedSector = null;
  };

  cov_1n0vzmhyuy.s[369]++;
  $scope.validateSector = function () {
    cov_1n0vzmhyuy.f[60]++;
    cov_1n0vzmhyuy.s[370]++;

    $scope.error_code = {};

    cov_1n0vzmhyuy.s[371]++;
    if ($scope.sectors.filter(function (sector) {
      cov_1n0vzmhyuy.f[61]++;
      cov_1n0vzmhyuy.s[372]++;

      return (cov_1n0vzmhyuy.b[78][0]++, $scope.selectedSector.NAME.toUpperCase() === sector.NAME.toUpperCase()) && (cov_1n0vzmhyuy.b[78][1]++, sector.id != $scope.selectedSector.id);
    }).length > 0) {
      cov_1n0vzmhyuy.b[77][0]++;
      cov_1n0vzmhyuy.s[373]++;

      $scope.error_code.name = true;
      cov_1n0vzmhyuy.s[374]++;
      return;
    } else {
      cov_1n0vzmhyuy.b[77][1]++;
    }

    cov_1n0vzmhyuy.s[375]++;
    $CRUDService.save('Sectors', { action: 'MiseAJour', valeur: $filter('json')($scope.selectedSector) }, function (data) {
      cov_1n0vzmhyuy.f[62]++;
      cov_1n0vzmhyuy.s[376]++;

      $scope.selectedSector.id = String(parseInt(data, 10));
      cov_1n0vzmhyuy.s[377]++;
      $scope.updateSector(angular.copy($scope.selectedSector));
      cov_1n0vzmhyuy.s[378]++;
      $scope.selectedSector = null;
    });
  };
  cov_1n0vzmhyuy.s[379]++;
  $scope.deleteSector = function (item) {
    cov_1n0vzmhyuy.f[63]++;
    cov_1n0vzmhyuy.s[380]++;

    SweetAlert.swal({
      title: $translate.instant('COMMON.CONFIRM'),

      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#c8c8c8',

      confirmButtonText: $translate.instant('COMMON.NO'),
      cancelButtonText: $translate.instant('COMMON.YES'),
      closeOnConfirm: true,
      closeOnCancel: true
    }, function (isconfirm) {
      cov_1n0vzmhyuy.f[64]++;
      cov_1n0vzmhyuy.s[381]++;

      if (isconfirm) {
        cov_1n0vzmhyuy.b[79][0]++;
        cov_1n0vzmhyuy.s[382]++;

        return;
      } else {
        cov_1n0vzmhyuy.b[79][1]++;
      }
      cov_1n0vzmhyuy.s[383]++;
      $scope.isloading = true;
      var validateItem = (cov_1n0vzmhyuy.s[384]++, {
        id: item.id
      });
      cov_1n0vzmhyuy.s[385]++;
      $CRUDService.delet('Sectors', { action: 'supp', id: item.id }, function (data) {
        cov_1n0vzmhyuy.f[65]++;
        cov_1n0vzmhyuy.s[386]++;

        if (data < 0) {
          cov_1n0vzmhyuy.b[80][0]++;
          cov_1n0vzmhyuy.s[387]++;

          SweetAlert.swal({
            title: $translate.instant('COMMON.ERROR_DELETE'),
            text: $translate.instant('PORTFOLIO.ERROR.DELETE')
          });
          cov_1n0vzmhyuy.s[388]++;
          $scope.isloading = false;
          cov_1n0vzmhyuy.s[389]++;
          return;
        } else {
          cov_1n0vzmhyuy.b[80][1]++;
        }
        cov_1n0vzmhyuy.s[390]++;
        $scope.updateSector({ id: validateItem.id }, true);
      });
    });
  };

  cov_1n0vzmhyuy.s[391]++;
  $scope.closeModal = function () {
    cov_1n0vzmhyuy.f[66]++;
    cov_1n0vzmhyuy.s[392]++;

    $uibModalInstance.dismiss('cancel');
  };
}